import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/internal/operators';

import * as uuid from 'uuid/v4';
import { environment } from '../../environments/environment';
import { Endpoints } from '../config/endpoints';
import { APP_VERSION } from '../config/version';
import { Approval } from '../dto/approval';
import { Attendance } from '../dto/attendance';
import { Holiday } from '../dto/holiday';
import { LeaveAllocation } from '../dto/leave-allocation';
import { LeaveType } from '../dto/leave-type';
import { Market } from '../dto/market';
import { MarketLevel } from '../dto/market-level';
import { Module } from '../dto/module';
import { Organization } from '../dto/organization';
import { OrganizationSettings } from '../dto/organization-settings';
import { TourPlan } from '../dto/tour-plan';
import { TourType } from '../dto/tour-type';
import { TrackingLocation } from '../dto/tracking-location';
import { User } from '../dto/user';
import { UserLeave } from '../dto/user-leave';
import { UserLeaveAccount } from '../dto/user-leave-account';
import { SalesReturnDetailsWithInvoice } from '../dto/sales-return/sales-return-details-with-invoice';
import { UserRole } from '../dto/user-role';
import { DailyShift } from '../dto/daily-shift';
import { SalesCenter } from '../dto/sales-center';
import { ProductLine } from '../dto/product-line';
import { ProductBrand } from '../dto/product-brand';
import { ProductType } from '../dto/product-type';
import { TherapeuticGroup } from '../dto/therapeutic-group';
import { GenericGroup } from '../dto/generic-group';
import { Product } from '../dto/product';
import { Degree } from '../dto/degree';
import { DoctorDesignation } from '../dto/doctor-designation';
import { DoctorCategory } from '../dto/doctor-category';
import { Speciality } from '../dto/speciality';
import { ChamberType } from '../dto/chamber-type';
import { PatientType } from '../dto/patient-type';
import { ContactType } from '../dto/contact-type';
import { SubSegment } from '../dto/sub-segment';
import { SpecialDay } from '../dto/special-day';
import { Doctor } from '../dto/doctor';
import { DoctorVisitType } from '../dto/doctor-visit-type';
import { DoctorVisit } from '../dto/doctor-visit';
import { AllowedPromotionType } from '../dto/allowed-promotion-type';
import { OrganizationPromotionType } from '../dto/organization-promotion-type';
import { InstituteType } from '../dto/institute-type';
import { Institute } from '../dto/institute';
import { PrescriptionType } from '../dto/prescription-type';
import { Prescription } from '../dto/prescription';
import { Competitor } from '../dto/competitor';
import { CompetitorProduct } from '../dto/competitor-product';
import { ChemistType } from '../dto/chemist-type';
import { Chemist } from '../dto/chemist';
import { Order } from '../dto/order';
import { MarketSalesTarget } from '../dto/market-sales-target';
import { MarketProductSalesTarget } from '../dto/market-product-sales-target';
import { Campaign } from '../dto/campaign';
import { LeaveAccount } from '../dto/leave-account';
import { ProductPrice } from '../dto/product-price';
import { Transport } from '../dto/transport';
import { DoctorVisitPlan } from '../dto/doctor-visit-plan';
import { Password } from '../dto/password';
import { TourPurpose } from '../dto/tour-purpose';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NoticeBoard } from '../dto/notice-board';
import { PaymentApproveRule } from '../dto/payment-approve-rule';
import { PaymentMethod } from '../dto/payment-method';
import { BankAccount } from '../dto/bank-account';
import { Payment } from '../dto/payment';
import { Training } from '../dto/training';
import { TrainingComment } from '../dto/trainingComment';
import { OrderProduct } from '../dto/order-product';
import { Stock } from '../dto/stock';
import { OrderApproveRule } from '../dto/order-approve-rule';
import { Invoice } from '../dto/invoice';
import { Delivery } from '../dto/delivery';
import { SampleStock } from '../dto/sample-stock';
import { TadaMarketRule } from '../dto/tada-market-rule';
import { UserLeaveApproveRule } from '../dto/user-leave-approve-rule';
import { CustomerApproveRule } from '../dto/customer-approve-rule';
import { DoctorApproveRule } from '../dto/doctor-approve-rule';
import { MilageClaim } from '../dto/milage-claim';
import { DistributorRoute } from '../dto/distributor-route';
import { TadaClaim } from '../dto/tada-claim';
import { Route } from '../dto/route';
import { ExpenseType } from '../dto/expense-type';
import { ExpenseclaimApproveRule } from '../dto/expenseclaim-approve-rule';
import { Expenseclaim } from '../dto/expenseclaim';
import { MonthlyAllowance } from '../dto/allowance';
import { VisitApproveRule } from '../dto/visit-approve-rule';
import { VisitType } from '../dto/visit-type';
import { Visit } from '../dto/visit';
import { SiteType } from '../dto/site-type';
import { SiteOwner } from '../dto/site-owner';
import { Site } from '../dto/site';
import { Surveyy } from '../dto/survey';
import { SurveyType } from '../dto/survey-type';
import { SurveyResponse } from '../dto/survey-response';
import { SurveyApproval } from '../dto/survey-approval';
import { FileInfo } from '../dto/filename';
import { TourPlanApproveRule } from '../dto/tour-plan-approve-rule';
import { NotificationMinute } from '../dto/notification-minute';
import { SeenRx } from '../dto/seen-rx';
import { DoctorImageType } from '../dto/doctor-image-type';
import { Segment } from '../dto/segment';
import { Department } from '../dto/department';
import { CentralStock } from '../dto/central-stock';
import { TransferFromCentralStock } from '../dto/transfer-from-central-stock';
import { DoctorOrder } from '../dto/doctor-order';
import { DailyTargetAchievement } from '../dto/daily-target-achievement';
import { SubSpeciality } from '../dto/sub-speciality';
import { TaDaApprovalRule } from '../dto/ta-da-approval-rule';
import { DoctorVisitLocations } from '../dto/doctor-visit-locations';
import { Weekend } from '../dto/weekend';
import { UserMonthlyRxTarget } from '../dto/user-monthly-rx-target';
import { TransferSampleStock } from '../dto/transfer-sample-stock';
import { RejectReason } from '../dto/reject-reason';
import { PrescriptionApproveRule } from '../dto/prescription-approve-rule';
import { MultipleLeave } from '../dto/multiple-leave';
import { ExpectedProduct } from '../dto/expected-product';
import { RxForm } from '../dto/rx-form';
import { FocusBrand } from '../dto/focus-brand';
import { Exam } from '../dto/exam';
import { ExamQuestion } from '../dto/exam-question';
import { AnswerPaper } from '../dto/answer-paper';
import { Return } from '../dto/return';
import { DistanceWiseTaDaRule } from '../dto/distance-wise-ta-da-rule';
import { CompetitorBrand } from '../dto/competitor-brand';
import { Depot } from '../dto/depot';
import { DepotProductUpload } from '../dto/depot-product-upload';
import { DepotRequisitionDetails } from '../dto/depot-requisition-details';
import { DepotChallanDetails } from '../dto/depot-challan-details';
import { DepotRequisitionRequest } from '../dto/depot-requisition-request';
import { CreateChallanFromRequisitionRequest } from '../dto/create-challan-from-requisition-request';
import { DepotChallanReceiveRequest } from '../dto/depot-challan-receive-request';
import { DepotTypeManage } from '../dto/depot-type-manage';
import { ActivationRequest } from '../dto/activation-request';
import { DepotManageRequest } from '../dto/depot-manage-request';
import { DepotUser } from '../dto/depot-user';
import { DepotProductBatchManageRequest } from '../dto/depot-product-batch-manage-request';
import { DmsLineItemOfferRequest } from '../dto/dms-line-item-offer-request';
import { DmsLineItemOfferDetails } from '../dto/dms-line-item-offer-details';
import { DmsTotalOrderAmountOfferDetails } from '../dto/dms-total-order-amount-offer-details';
import { DmsTotalOrderAmountOfferRequest } from '../dto/dms-total-order-amount-offer-request';
import { DmsOrderDetails } from '../dto/dms-order-details';
import { DmsInvoiceRequest } from '../dto/dms-invoice-request';
import { DmsPricePreview } from '../dto/dms-price-preview';
import { DmsInvoiceDetails } from '../dto/dms-invoice-details';
import { DmsPaymentRequest } from '../dto/dms-payment-request';
import { DmsPaymentDetails } from '../dto/dms-payment-details';
import { DmsReturnReasonManage } from '../dto/dms-return-reason/dms-return-reason-manage';
import { RxSurveyType } from '../dto/rx-survey-type';
import { RxSurvey } from '../dto/rx-survey';
import { DmsSalesReturnDetails } from '../dto/sales-return/dms-sales-return-details';
import { DmsReturnReason } from '../dto/dms-return-reason/dms-return-reason';
import { DmsSalesReturnRequest } from '../dto/dms-sales-return-request';
import { DmsApproval } from '../dto/dms-approval';
import { SurveyDoctor } from '../dto/survey-doctor';
import {
    TourPlanMarketFrequencyOfAPerson,
    TourPlanOfAPerson,
    TourPlanTourTypeFrequency
} from '../dto/tour-plan-of-a-person';
import { DoctorRecord } from '../dto/doctor-record';
import { DoctorRecordUpload } from '../dto/doctor-record-upload';
import { KeyValue } from '../dto/key-value';
import { MinifiedProduct } from '../dto/minified-product';
import { UserRxMonthlyTargetAndCount } from '../dto/user-rx-monthly-target-and-count';
import { InvoiceSync } from '../dto/invoice-sync';
import { DmsInvoiceType } from '../dto/dms-invoice-list';
import { DeliveryReturn } from '../dto/delivery-return';
import { DoctorServiceProposalTypeRequest } from '../dto/doctor-service-proposal-type-request';
import { DoctorServiceProposalDetailDto } from '../dto/doctor-service-proposal-detail-dto';
import { DoctorPaymentMethodDto } from '../dto/doctor-payment-method-dto';
import { DoctorServiceProposalTypeDto } from '../dto/doctor-service-proposal-type-dto';
import { PaymentCollection, PaymentCollectionManage } from '../dto/payment-collection';
import { DmsFlatRateRequest } from '../dto/dms-flat-rate-request';
import { DmsFlatRateDetails } from '../dto/dms-flat-rate-details';
import {
    CampaignDiscountOnSaleDetails,
    CampaignDiscountOnSaleList,
    CampaignDiscountOnSaleRequest
} from '../dto/campaign-discount-on-sale';
import { DmsBonusDetails } from '../dto/dms-bonus-details';
import { DmsBonusRequest } from '../dto/dms-bonus-request';
import { DmsSpecialCampaignDetails, DmsSpecialCampaignRequest } from '../dto/dms-special-campaign-list';
import { DmsPartyCampaignDetails, DmsPartyCampaignRequest } from '../dto/dms-party-campaign-list';
import { PatientCreateDto, PatientDetailsDto } from '../dto/patient/patient';
import { base_urls } from '../config/base-url';
import { PatientRxOrderCreateDto } from '../dto/patient-rx-order/patient-rx-order-create';
import { PatientRxOrderDetails } from '../dto/patient-rx-order/patient-rx-order-details';
import { PatientMpo } from '../dto/patient/patient-mpo';
import { PatientRxOrderDoctor } from '../dto/patient-rx-order/patient-rx-order-doctor';
import { AdjustDepotStock } from '../dto/adjust-depot-stock';
import { OptionalCampaigns, OrderAlphaDetails, OrderAlphaPreview, OrderAlphaRequest } from '../dto/order-alpha-details';
import { InvoiceAlphaDetails, InvoiceAlphaPreview, InvoiceAlphaRequest } from '../dto/invoice-alpha-details';
import { IncentiveRuleList } from '../dto/incentive-list';
import { DeliveryReturnCreateReq } from '../dto/delivery-return/delivery-return-create-req';
import { DeliveryReturnDetails } from '../dto/delivery-return-details';
import { AppConfigService } from './app-config.service';
import { IncentiveUpload } from '../dto/incentive/incentive-upload';
import { FreeChallanPurposeCreateRequest } from '../dto/free-challan-purpose/free-challan-purpose-create-request';
import { FreeChallanPurposeUpdateRequest } from '../dto/free-challan-purpose/free-challan-purpose-update-request';
import { FreeChallanIssueListRequest } from '../dto/free-challan-issue/free-challan-issue-list-request';
import { FreeChallanIssueCreateRequest } from '../dto/free-challan-issue/free-challan-issue-create-request';
import { FreeChallanIssueDetailsDto } from '../dto/free-challan-issue/free-challan-issue-details-dto';
import { ReplacementRequestCreateRequest } from '../dto/replacement-request/replacement-request-create-request';
import { ReplacementRequestEditRequest } from '../dto/replacement-request/replacement-request-edit-request';
import { ReplacementRequestDetailsDto } from '../dto/replacement-request/replacement-request-details-dto';
import { InvoiceAlphaByReplacementRequest } from '../dto/replacement-invoice/invoice-alpha-by-replacement-request';
import { InvoiceAlphaByReplacementEditRequest } from '../dto/replacement-invoice/invoice-alpha-by-replacement-edit-request';
import { InvoiceAlphaBulkByReplacementRequest } from '../dto/replacement-invoice/invoice-alpha-bulk-by-replacement-request';

import { InvoiceBulkUpload } from '../dto/patient-rx-order/invoice-bulk-upload';
import { UserLastLocations } from '../dto/user-location/user-last-locations';
import { UserTimeLineByDate } from '../dto/user-location/user-timeline-by-date';
import { InvoiceDueInfo } from '../dto/payment-collection/invoice-due-info';
import { PaymentCollectionRequest } from '../dto/payment-collection/payment-collection-request';
import { GeneralApprovalRule } from '../dto/general-approval-rule';
import { RoleWiseDailyAllowance, RoleWiseDailyAllowanceDetails } from '../dto/role-wise-daily-allowance';
import { VehicleDetails, VehicleRequest } from '../dto/vehicle-details';
import { OrderAlphaDetailsByMpo } from '../dto/order-alpha/order-alpha-details-by-mpo';
import { PartyTypeCampaignDetails } from '../dto/dms-campaigns/party-type-campaign/party-type-campaign-details';
import { PartyTypeCampaignManage } from '../dto/dms-campaigns/party-type-campaign/party-type-campaign-manage';
import { BundleOfferCampaignDetails } from '../dto/dms-campaigns/bundle-offer-campaign/bundle-offer-campaign-details';
import { BundleOfferCampaignManage } from '../dto/dms-campaigns/bundle-offer-campaign/bundle-offer-campaign-manage';
import { MixedProductOfferDetails } from '../dto/dms-campaigns/mix-product-offer/mixed-product-offer-details';
import { MixedProductOfferManage } from '../dto/dms-campaigns/mix-product-offer/mixed-product-offer-manage';
import { WeekendDetails } from '../dto/weekend/weekend-details';
import { WeekendEditReq } from '../dto/weekend/weekend-edit-req';
import { ChemistCreditUpdateReq } from '../dto/chemist/credit/credit-update-req';
import { ChemistCreditDetails } from '../dto/chemist/credit/credit-details';
import { ProductDose } from '../dto/product-dose';
import { MonthlyAllowanceDetails } from '../dto/user-allowance/monthly-allowance-details';
import { RoleWiseAllowanceAdd } from '../dto/role-wise-daily-allowance/role-wise-allowance-add';
import { MpoMarketLevel } from '../dto/market/mpo-market-level';
import { MarketAndUserOfALevel } from '../dto/user/market-and-user-of-a-level';
import { UserOfASpecificMarket } from '../dto/user/user-of-a-specific-market';
import { MpoWisePaymentChemist } from '../dto/chemist/mpo-wise-payment-chemist';
import { InvoiceOfChemist } from '../dto/payment-collection/invoice-of-chemist';
import { MpoListDto } from '../dto/user/mpo-list-dto';
import { SampleGiftChallanProduct } from '../dto/sample-gift-challan/sample-gift-challan-product';
import { SampleGiftChallanFieldForce } from '../dto/sample-gift-challan/sample-gift-challan-field-force';
import { DeliveryTopSheetReq } from '../dto/invoice-alpha/delivery-top-sheet-req';
import { InvoiceTag } from '../dto/invoice-alpha/invoice-tag';
import {MarketWiseTargetMarketHierarchyRes} from '../dto/target/market-sales-target/market-hierarchy-res';
import {DistrictListDto} from '../dto/geo-market/district/district-list-dto';
import {DistrictManageDto} from '../dto/geo-market/district/district-manage-dto';
import {ThanaDto} from '../dto/geo-market/thana/thana-dto';
import {ThanaManageDto} from '../dto/geo-market/thana/thana-manage-dto';
import {UnionDto} from '../dto/geo-market/union/union-dto';
import {UnionManageDto} from '../dto/geo-market/union/union-manage-dto';
import {
    MarketProductListMarketDto
} from '../dto/target/market-product-wise-sales-target/market-product-list-market-dto';
import {StockCheckForOrderDto} from '../dto/order-alpha/stock-check-for-order-dto';
import {ChemistApprovalRuleListDto} from '../dto/chemist/chemist-approval-rule/chemist-approval-rule-list-dto';
import {ChemistDetailsMicroservice} from '../dto/chemist-details-mircroservice';
import {
    MarketProductTargetDeleteRequest
} from '../dto/target/market-product-wise-sales-target/market-product-target-delete-req';
import {MpoDueByInvoiceId} from '../dto/payment-collection/mpo-due-by-invoice-id';
import {BrandTagManageDto} from '../dto/product-brand-tag/brand-tag-manage';
import {ProductBrandManagementDto} from '../dto/product-brand/product-brand-manage-dto';
import {RxFrequencyListRes} from '../dto/doctor-report/rx-dcr-frequency-report/rx-frequency-list-res';

@Injectable({ providedIn: 'root' })
export class BaseService {

    segmentsForReports: Segment[] = [];

    constructor(private http: HttpClient, private deviceService: DeviceDetectorService, private config: AppConfigService) {

    }

    get accessToken(): string {
        return localStorage.getItem('access_token');
    }

    get refreshToken(): string {
        return localStorage.getItem('refresh_token');
    }

    get uuid(): string {
        return localStorage.getItem('uuid') || this._generateUUID();
    }

    _generateUUID(): string {
        const uuidString = uuid();
        localStorage.setItem('uuid', uuidString);
        return uuidString;
    }

    _generateGUID(): string {
        const uuidString = uuid();
        localStorage.setItem('guid', uuidString);
        return uuidString;
    }

    _generateQueryStringFromObject(query: any): string {
        return Object.keys(query).map(key => {
            if (query[key] != null) {
                if (typeof query[key] === 'object') {
                    const singleArray = [];
                    for (const singleArrIndex of query[key]) {
                        singleArray.push(singleArrIndex);
                    }
                    return key + '=' + singleArray.join(',') + '&';
                } else {
                    return key + '=' + query[key] + '&';
                }

            } else {
                return '';
            }
        }
        ).join('');
    }

    getHeaders(includeToken: boolean = true): HttpHeaders {
        const headers = {};

        if (includeToken) {
            headers['Authorization'] = `Bearer ${this.accessToken}`;
            headers['client_uuid'] = this.uuid;
            headers['client_type'] = 'BROWSER';
            headers['app_version_name'] = APP_VERSION;
            headers['os'] = this.deviceService.os;
            headers['os_version'] = this.deviceService.os_version;
        } else {
            headers['Authorization'] = 'Basic Yml6bW90aW9uMjAxOToyMDE5MjAyMA==';
            headers['Content-Type'] = 'application/x-www-form-urlencoded';
        }
        return new HttpHeaders(headers);
    }

    getModuleListForOrganization(pParameters: any): Observable<Module[]> {
        return this.postData(Endpoints.organization_modules, pParameters).pipe(map(response => response['Data']['content']));
    }

    getModuleListForUserRole(pParameters: any): Observable<Module[]> {
        return this.postData(Endpoints.user_role_modules, pParameters).pipe(map(response => response['Data']['content']));
    }

    getOrganizationList(pParameters: any): Observable<Organization[]> {
        return this.postData(Endpoints.organization_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getOrganizationListForLogin(pParameters: any): Observable<Organization[]> {
        return this.getPublicData(Endpoints.organization_list_login, pParameters).pipe(map(response => response['Data']['content']));
    }

    generateGetUrl(apiEndpoint: string, data?: any, fileName?: string, includeToken: boolean = true): string {
        return this.config.apiUrl + base_urls.pharmaws + apiEndpoint + '?' + (includeToken ? 'access_token=' + this.accessToken + '&' : '') + (fileName ? 'DownloadFileName=' + fileName + '&' : '') + (data ? this._generateQueryStringFromObject(data) : '');
    }

    generateMicroServiceGetUrl(apiEndpoint: string, data?: any, fileName?: string, includeToken: boolean = true): string {
        return this.config.apiUrl + apiEndpoint + '?' + (includeToken ? 'access_token=' + this.accessToken + '&' : '') + (fileName ? 'DownloadFileName=' + fileName + '&' : '') + (data ? this._generateQueryStringFromObject(data) : '');
    }

    generateAsyncGetUrl(apiEndpoint: string, data?: any, fileName?: string, includeToken: boolean = true): Observable<any> {
        return this.getData(apiEndpoint + '?' + (includeToken ? 'access_token=' + this.accessToken + '&' : '')
            + (fileName ? 'DownloadFileName=' + fileName + '&' : '') + (data ? this._generateQueryStringFromObject(data) : ''))
            .pipe(map(response => response['Data']));
    }

    generateAsyncGetUrlForMicroservice(apiEndpoint: string, data?: any, fileName?: string, includeToken: boolean = true): Observable<any> {
        return this.getDataForMicroService(apiEndpoint + '?' + (includeToken ? 'access_token=' + this.accessToken + '&' : '')
            + (fileName ? 'downloadFileName=' + fileName + '&' : '') + (data ? this._generateQueryStringFromObject(data) : ''))
            .pipe(map(response => response['data']));
    }

    generateAsyncPostUrl(apiEndpoint: string, data?: any, fileName?: string, includeToken: boolean = true): Observable<any> {
        const payload = {
            ...data,
            DownloadFileName: fileName
        };
        return this.postData(apiEndpoint, payload)
            .pipe(map(response => response['Data']));
    }

    generateAsyncPostUrlForMicroservice(apiEndpoint: string, data?: any, fileName?: string, includeToken: boolean = true): Observable<any> {
        return this.postDataForMicroService(apiEndpoint, (data ? data : '')).pipe(map(response => response['data']));
    }

    getOrganizationDetails(pOrganizationId: number): Observable<Organization> {
        return this.getData(`${Endpoints.organization_details}/${pOrganizationId}`)
            .pipe(map(response => response['Data']['Organization']));
    }

    generateExportStatus(pRequestId: string): Observable<any> {
        return this.getData(`${Endpoints.generate_export_status}?request_id=${pRequestId}`).pipe(map(response => response['Data']));
    }

    updateAndroidAppInfo(pOrganization: any): Observable<any> {
        return this.postData(Endpoints.app_update, pOrganization);
    }

    saveOrganization(pOrganization: Organization): Observable<any> {
        return this.postData(pOrganization.Id ? Endpoints.organization_edit : Endpoints.organization_add, pOrganization);
    }

    deleteOrganization(pOrganizationId: number): Observable<any> {
        return this.deleteData(`${Endpoints.organization_delete}/${pOrganizationId}`);
    }

    getOrganizationSettings(pOrganizationId?: number): Observable<OrganizationSettings[]> {
        return this.postData(Endpoints.organization_settings, { 'OrganizationId': pOrganizationId ? pOrganizationId : null }).pipe(map(response => response['Data']['content']));
    }

    addBillPendingOrganization(pOrganizationId: any): Observable<any> {
        return this.postData(Endpoints.add_bill_pending_organization, pOrganizationId);
    }

    deleteBillPendingOrganization(pOrganizationId: number): Observable<any> {
        return this.deleteData(`${Endpoints.delete_bill_pending_organization}/${pOrganizationId}`);
    }

    setRestrictionMessage(pMessage: any): Observable<any> {
        return this.postData(Endpoints.set_restriction_message, pMessage);
    }

    getRestrictionMessage(pMessage: any): Observable<any> {
        return this.getData(Endpoints.get_restriction_message, pMessage).pipe(map(response => response['Data']['Message']));
    }

    getNotificationList(pParameters: any): Observable<NotificationMinute[]> {
        return this.postData(Endpoints.notification_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getRoute(pRouteId: number): Observable<Route> {
        return this.getData(`${Endpoints.route_details}/${pRouteId}`)
            .pipe(map(response => response['Data']['DistributionRoute']));
    }

    saveRoute(pRoute: Route): Observable<Route> {
        return this.postData(pRoute.Id ? Endpoints.route_edit : Endpoints.route_add, pRoute);
    }

    utilityUpload(file: FormData): Observable<any> {
        return this.postData(Endpoints.utility_upload, file);
    }

    utilityUploadCategoryWise(file: FormData, category: string): Observable<any> {
        const endpoint = `${Endpoints.utility_upload}/${category}`;
        return this.postData(endpoint, file);
    }

    getFileName(pId: string): Observable<FileInfo> {
        return this.getFile(`${pId}`).pipe(map(response => response['Data']['FileInfo']));
    }

    getData(apiEndpoint: string, data?: any, includeToken: boolean = true): Observable<any> {
        return this.http.get(this.config.apiUrl + base_urls.pharmaws + apiEndpoint, {
            params: new HttpParams({ fromObject: data }),
            headers: this.getHeaders(includeToken)
        });
    }

    getDataForBase64Image(apiEndpoint: string, data?: any, includeToken: boolean = true): Observable<any> {
        return this.http.get(apiEndpoint, {
            params: new HttpParams({ fromObject: data }),
            headers: this.getHeaders(includeToken),
            responseType: 'text'
        });
    }

    getDataForMicroService(apiEndpoint: string, data?: any, includeToken: boolean = true): Observable<any> {
        if (data) {
            data.access_token = this.accessToken;
        }
        return this.http.get(this.config.apiUrl + apiEndpoint, {
            params: new HttpParams({ fromObject: data }),
            headers: this.getHeaders(includeToken)
        });
    }

    getPublicData(apiEndpoint: string, data?: any, includeToken: boolean = false): Observable<any> {
        return this.http.get(this.config.apiUrl + base_urls.pharmaws + apiEndpoint, {
            params: new HttpParams({ fromObject: data }),
            headers: this.getHeaders(includeToken)
        });
    }

    getFile(apiEndpoint: string, data?: any, includeToken: boolean = true): Observable<any> {
        return this.http.get(apiEndpoint, {
            params: new HttpParams({ fromObject: data }),
            headers: this.getHeaders(includeToken)
        });
    }

    postData(apiEndpoint: string, data: any, includeToken: boolean = true): Observable<any> {
        data.Guid = this._generateGUID();
        return this.http.post(this.config.apiUrl + base_urls.pharmaws + apiEndpoint, data, { headers: this.getHeaders(includeToken) });
    }

    postDataForMicroService(apiEndpoint: string, data?: any, includeToken: boolean = true, userName?: string): Observable<any> {
        let queryParams = {};
        if (userName) {
            queryParams = {
                access_token: this.accessToken,
                createdBy: userName
            };
        } else {
            queryParams = {
                access_token: this.accessToken
            };
        }
        return this.http.post(this.config.apiUrl + apiEndpoint, data, {
            params: new HttpParams({
                fromObject: queryParams
            }),
            headers: this.getHeaders(includeToken)
        });
    }

    postDataForMicroServiceForPdf(apiEndpoint: string, data?: any, includeToken: boolean = true, userName?: string): Observable<any> {
        return this.http.post(this.config.apiUrl + apiEndpoint, data, {
            headers: this.getHeaders(includeToken),
            responseType: 'blob' as 'json',
            observe: 'response'
        }
        );
    }

    urlToFile(url: string): Observable<Blob> {
        return this.http.get(url, { responseType: 'blob' });
    }

    putData(apiEndpoint: string, data: any, includeToken: boolean = true): Observable<any> {
        return this.http.put(this.config.apiUrl + base_urls.pharmaws + apiEndpoint, new HttpParams({ fromObject: data }), { headers: this.getHeaders(includeToken) });
    }

    deleteData(apiEndpoint: string, data?: any, includeToken: boolean = true): Observable<any> {
        return this.http.delete(this.config.apiUrl + base_urls.pharmaws + apiEndpoint, {
            params: new HttpParams({ fromObject: data }),
            headers: this.getHeaders(includeToken)
        });
    }

    putDataForMicroService(apiEndpoint: string, data?: any, includeToken: boolean = true, userName?: string): Observable<any> {
        let queryParams = {};
        if (userName) {
            queryParams = {
                access_token: this.accessToken,
                createdBy: userName
            };
        } else {
            queryParams = {
                access_token: this.accessToken
            };
        }
        return this.http.put(this.config.apiUrl + apiEndpoint, data, {
            params: new HttpParams({ fromObject: queryParams }),
            headers: this.getHeaders(includeToken)
        });
    }

    deleteDataForMicroService(apiEndpoint: string, data?: any, includeToken: boolean = true): Observable<any> {
        return this.http.delete(this.config.apiUrl + apiEndpoint, {
            params: new HttpParams({ fromObject: data }),
            headers: this.getHeaders(includeToken)
        });
    }


    getCustomerApprove(pCustomerRuleId: number): Observable<CustomerApproveRule> {
        return this.getData(`${Endpoints.customer_approve_details}/${pCustomerRuleId}`)
            .pipe(map(response => response['Data']['PaymentApprovalRule']));
    }

    getSurveyApprove(pVisitRuleId: number): Observable<VisitApproveRule> {
        return this.getData(`${Endpoints.survey_approve_details}/${pVisitRuleId}`)
            .pipe(map(response => response['Data']['PaymentApprovalRule']));
    }

    getSurveyType(pTransportId: number): Observable<SurveyType> {
        return this.getData(`${Endpoints.survey_type_details}/${pTransportId}`)
            .pipe(map(response => response['Data']['SurveyType']));
    }

    saveSurvey(pSurvey: Surveyy): Observable<Surveyy> {
        return this.postData(pSurvey.Id ? Endpoints.survey_edit : Endpoints.survey_add, pSurvey);
    }

    saveSurveyResponse(pSurvey: SurveyResponse): Observable<SurveyResponse> {
        return this.postData(pSurvey.Id ? Endpoints.survey_response_edit : Endpoints.survey_response_add, pSurvey);
    }

    getSurveyTypeList(pParameters: any): Observable<SurveyType[]> {
        return this.postData(Endpoints.survey_type_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    approveSurveyResponse(pApproval: SurveyApproval): Observable<any> {
        return this.postData(Endpoints.survey_response_approve, pApproval);
    }

    getAllowedPromotionTypeList(pOrganizationId?: number): Observable<AllowedPromotionType[]> {
        return this.postData(Endpoints.allowed_promotion_type_list, { 'OrganizationId': pOrganizationId ? pOrganizationId : null }).pipe(map(response => response['Data']['content']));
    }

    saveAllowedPromotionType(pOrganizationPromotionType: OrganizationPromotionType): Observable<any> {
        return this.postData(Endpoints.allowed_promotion_type_save, pOrganizationPromotionType);
    }

    saveSurveyChemistApproveRule(pVisitApproveRule: VisitApproveRule): Observable<VisitApproveRule> {
        return this.postData(pVisitApproveRule.Id ? Endpoints.survey_chemist_approve_edit : Endpoints.survey_chemist_approve_add, pVisitApproveRule);
    }

    saveSurveyDoctorApproveRule(pVisitApproveRule: VisitApproveRule): Observable<VisitApproveRule> {
        return this.postData(pVisitApproveRule.Id ? Endpoints.survey_doctor_approve_edit : Endpoints.survey_doctor_approve_add, pVisitApproveRule);
    }

    saveTeamApproveRule(pOrderApproveRule: VisitApproveRule): Observable<VisitApproveRule> {
        return this.postData(pOrderApproveRule.Id ? Endpoints.survey_team_approve_edit : Endpoints.survey_team_approve_add, pOrderApproveRule);
    }

    saveCustomerApproveRule(pCustomerApproveRule: CustomerApproveRule): Observable<CustomerApproveRule> {
        return this.postData(pCustomerApproveRule.Id ? Endpoints.customer_approve_edit : Endpoints.customer_approve_add, pCustomerApproveRule);
    }

    saveSurveyType(pTransport: SurveyType): Observable<SurveyType> {
        return this.postData(pTransport.Id ? Endpoints.survey_type_edit : Endpoints.survey_type_add, pTransport);
    }

    getSurveyDetails(pId: number): Observable<Surveyy> {
        return this.getData(`${Endpoints.survey_details}/${pId}`).pipe(map(response => response['Data']['Survey']));
    }

    setUserRoleTeam(pList): Observable<any> {
        return this.postData(Endpoints.set_user_role_team, pList).pipe(map(response => response['Data']));
    }

    getOrganizationLogoInBase64(pUrl: string): Observable<string> {
        return this.getDataForBase64Image(pUrl);
    }

    /** Dashboard Menu Starts*/

    getDashboardRoleWisePresenceCount(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_role_wise_presence_count, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDashboardMarketWisePendingCount(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_market_wise_pending_count, pParameters).pipe(map(response => response['Data']));
    }

    getDashboardMarketWisePresenceCount(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_market_wise_presence_count, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDashboardMarketAndRoleWisePresentAbsentCount(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_market_and_role_wise_presence_absent_count, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDashboardMarketRoleShiftWisePresenceCount(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_market_role_shift_wise_presence_count, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDashboardPrescriptionCount(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_total_prescription_count, pParameters).pipe(map(response => response['Data']['Count']));
    }

    getDashboardMarketWisePrescriptionCount(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_market_wise_prescription_count, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDashboardTotalDcrCount(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_total_dcr_count, pParameters).pipe(map(response => response['Data']['Count']));
    }

    getDashboardDoctorVisitSubmittedByCount(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_total_submitted_by_dcr_count, pParameters).pipe(map(response => response['Data']['Count']));
    }

    getDashboardMarketWiseDcrCount(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_market_wise_dcr_count, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDashboardVisitedDoctorCount(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_visited_doctor_count, pParameters).pipe(map(response => response['Data']['Count']));
    }

    getDashboardMarketWiseVisitedDoctorCount(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_market_wise_visited_doctor_count, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDashboardMarketWiseTotalDoctorCount(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_market_wise_total_doctor_count, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDashboardPlannedDoctorCount(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_planned_doctor_count, pParameters).pipe(map(response => response['Data']['Count']));
    }

    getDashboardMarketWisePlannedDoctorCount(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_market_wise_planned_doctor_count, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDashboardMarketWiseDoctorCount(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_market_wise_doctor_count, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDashboardMarketWiseSubmittedDcrByUser(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_submitted_dcr_by_user, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDashboardMarketWiseSubmittedRxByUser(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_submitted_rx_by_user, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDashboardTotalRxCount(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_total_rx_count, pParameters).pipe(map(response => response['Data']['Count']));
    }

    getDashboardMarketWiseRxCount(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_market_wise_rx_count, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDashboardRxCapturedCount(pParameters: any): Observable<any> {
        return this.postData(Endpoints.dashboard_rx_captured_count, pParameters).pipe(map(response => response['Data']['UserCount']));
    }

    getDashboardFocusBrandWiseRxCount(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_focus_brand_wise_count, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDashboardFocusBrandAndDateWiseRxCount(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_date_wise_focus_brand_count, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDashboardBrandsInRx(pParameters: any): Observable<any> {
        return this.postData(Endpoints.dashboard_brands_in_rx, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDashboardAttendanceCount(pParameters: any): Observable<any> {
        return this.postData(Endpoints.dashboard_attendance_count, pParameters).pipe(map(response => response['Data']['DayWiseCount']));
    }

    getDashboardOrderAmount(pParameters: any): Observable<any> {
        return this.postData(Endpoints.dashboard_order_amount, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDashboardChemistVisitCount(pParameters: any): Observable<any> {
        return this.postData(Endpoints.dashboard_chemist_visit_count, pParameters).pipe(map(response => response['Data']));
    }

    getDashboardDcrCount(pParameters: any): Observable<any> {
        return this.postData(Endpoints.dashboard_dcr_count, pParameters).pipe(map(response => response['Data']));
    }

    getDashboardRxCount(pParameters: any): Observable<any> {
        return this.postData(Endpoints.dashboard_rx_count, pParameters).pipe(map(response => response['Data']));
    }

    getDashboardOrderCount(pParameters: any): Observable<any> {
        return this.postData(Endpoints.dashboard_order_count, pParameters).pipe(map(response => response['Data']));
    }

    getDashboardDayWiseUserDcrCount(pParameters: any): Observable<any> {
        return this.postData(Endpoints.dashboard_day_wise_user_dcr_count, pParameters).pipe(map(response => response['Data']));
    }

    getDashboardTodaysRX(pParameters: any): Observable<any> {
        return this.postData(Endpoints.dashboard_todays_rx_captured, pParameters).pipe(map(response => response['Data']));
    }

    getDashboardBrandWiseOrderCount(pParameters: any): Observable<any> {
        return this.postData(Endpoints.dashboard_brandwise_order_count, pParameters).pipe(map(response => response['Data']));
    }

    getDashboardMarketRXCount(pParameters: any): Observable<any> {
        return this.postData(Endpoints.dashboard_todays_rx_count, pParameters).pipe(map(response => response['Data']));
    }

    getDashboardBrandInRXCount(pParameters: any): Observable<any> {
        return this.postData(Endpoints.dashboard_todays_brand_in_rx_count, pParameters).pipe(map(response => response['Data']));
    }

    getChemistCoverageCount(pParameters: any): Observable<any> {
        return this.postData(Endpoints.dashboard_chemist_coverage_count, pParameters).pipe(map(response => response['Data']));
    }

    getDailyDoctorOrder(pParameters: any): Observable<any> {
        return this.postData(Endpoints.daily_doctor_order_count, pParameters).pipe(map(response => response['Data']));
    }

    getBrandDCRCount(pParameters: any): Observable<any> {
        return this.postData(Endpoints.brand_dcr_count, pParameters).pipe(map(response => response['Data']['content']));
    }

    getBrandRXCount(pParameters: any): Observable<any> {
        return this.postData(Endpoints.brand_rx_count, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDashboardHitCount(pParameters: any): Observable<any> {
        return this.getData(Endpoints.dashboard_hit_count, pParameters).pipe(map(response => response['Data']['List']));
    }

    getDashboardKeyValue(pParameters: string): Observable<KeyValue> {
        return this.getData(Endpoints.dashboard_key_value + pParameters).pipe(map(response => response['Data']['KeyValue']));
    }

    setDashboardKeyValue(pKeyValue: KeyValue): Observable<any> {
        return this.postData(Endpoints.dashboard_key_value_manage, pKeyValue).pipe(map(response => response['Data']));
    }

    /** Dashboard Menu Ends*/

    /** Chemist Menu Starts*/

    getChemistDetails(pChemistId: number): Observable<Chemist> {
        return this.getData(`${Endpoints.chemist_details}/${pChemistId}`).pipe(map(response => response['Data']['Chemist']));
    }

    getChemistDetailsForMicroService(pUrl: string, pChemistId: number): Observable<ChemistDetailsMicroservice> {
        return this.postDataForMicroService(`${pUrl + Endpoints.chemist_details_v2}?id=${pChemistId}`).pipe(map(response => response['data']));
    }

    getChemistTypeList(pParameters: any): Observable<ChemistType[]> {
        return this.postData(Endpoints.chemist_type_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getChemistTypeDetails(pChemistTypeId: number): Observable<ChemistType> {
        return this.getData(`${Endpoints.chemist_type_details}/${pChemistTypeId}`).pipe(map(response => response['Data']['ChemistType']));
    }

    saveChemistType(pChemistType: ChemistType): Observable<any> {
        return this.postData(pChemistType.Id ? Endpoints.chemist_type_edit : Endpoints.chemist_type_add, pChemistType);
    }

    getChemistList(pParameters: any): Observable<Chemist[]> {
        return this.postData(Endpoints.chemist_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getChemistListForMpoPayment(pParameters: any, url: string): Observable<MpoWisePaymentChemist[]> {
        return this.postDataForMicroService(url + Endpoints.chemist_list_for_mpo_wise_payment, pParameters).pipe(map(response => response['data']));
    }

    createSampleGiftChallan(pRequest: any): Observable<any> {
        return this.postDataForMicroService(base_urls.dms + Endpoints.sample_gift_challan_create, pRequest);
    }

    updateSampleGiftChallan(pRequest: any): Observable<any> {
        return this.postDataForMicroService(base_urls.dms + Endpoints.sample_gift_challan_edit, pRequest);
    }

    // Free Challan Purpose

    addFreeChallanPurpose(payload: FreeChallanPurposeCreateRequest, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.free_challan_purpose_add, payload).pipe(map(response => response['data']));
    }

    updateFreeChallanPurpose(payload: FreeChallanPurposeUpdateRequest, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.free_challan_purpose_edit, payload).pipe(map(response => response['data']));
    }

    activateFreeChallanPurpose(payload, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.free_challan_purpose_activate, payload).pipe(map(response => response));
    }


    getChemistBookedAmount(pChemistId: number): Observable<any> {
        return this.getDataForMicroService(base_urls.dms + `${Endpoints.chemist_booked_amount}/${pChemistId}`).pipe(map(response => response));
    }

    saveChemist(pChemist: Chemist): Observable<any> {
        return this.postData(pChemist.Id ? Endpoints.chemist_edit : Endpoints.chemist_add, pChemist);
    }

    approveChemist(pApproval: Approval): Observable<any> {
        return this.postData(Endpoints.chemist_approve, pApproval);
    }

    approveChemistForMicroService(pUrl: string, pApproval: any): Observable<any> {
        return this.postDataForMicroService(pUrl + Endpoints.chemist_approve_v2, pApproval);
    }

    bulkApproveChemistsForMicroService(pUrl: string, pApproval: any): Observable<any> {
        return this.postDataForMicroService(pUrl + Endpoints.chemist_bulk_approve_v2, pApproval);
    }

    shiftChemistMarket(pFromMarketId: number, pToMarketId: number): Observable<any> {
        return this.postDataForMicroService(base_urls.p_base + Endpoints.chemist_shift_market, {fromMarketId: pFromMarketId, toMarketId: pToMarketId});
    }

    shiftDoctorMarket(pFromMarketId: number, pToMarketId: number): Observable<any> {
        return this.postDataForMicroService(base_urls.p_base + Endpoints.doctor_shift_market, {fromMarketId: pFromMarketId, toMarketId: pToMarketId});
    }

    deleteChemistLocation(pChemistId: number): Observable<any> {
        return this.deleteData(`${Endpoints.chemist_location_delete}/${pChemistId}`);
    }

    getChemistReturnBalance(pChemistId: number): Observable<any> {
        return this.getData(`${Endpoints.chemist_return_balance}/${pChemistId}`).pipe(map(response => response['Data']['Chemist']['Available']));
    }

    getChemistBalance(pChemistId: number): Observable<any> {
        return this.getData(`${Endpoints.chemist_balance}/${pChemistId}`).pipe(map(response => response['Data']['Chemist']));
    }

    updateChemistCredit(param: ChemistCreditUpdateReq): Observable<ChemistCreditDetails> {
        return this.postData(Endpoints.update_chemist_credit_limit, param).pipe(map(response => response['Data']['Result']));
    }

    deleteChemistApproveRule(pCustomerApproveRuleId: number): Observable<any> {
        return this.deleteData(Endpoints.chemist_approval_rule_delete + '/' + pCustomerApproveRuleId);
    }

    saveChemistApproveRule(payload: any): Observable<any> {
        return this.postData(Endpoints.chemist_approval_rule_add, payload);
    }

    getChemistApprovalRuleList(params: any): Observable<ChemistApprovalRuleListDto[]> {
        return this.postData(Endpoints.update_chemist_credit_limit, params).pipe(map(response => response['Data']['content']));
    }

    /** Chemist Menu Ends*/

    /** Doctor & Institute Menu Starts*/
    // doctor
    getDoctorDetails(pDoctorId: number): Observable<Doctor> {
        return this.getData(`${Endpoints.doctor_details}/${pDoctorId}`).pipe(map(response => response['Data']['Doctor']));
    }

    saveDoctor(pDoctor: Doctor): Observable<any> {
        return this.postData(pDoctor.Id ? Endpoints.doctor_edit : Endpoints.doctor_add, pDoctor);
    }

    getAdjacentChemistsByDoctor(pDoctorId: number): Observable<Chemist[]> {
        return this.getData(`${Endpoints.doctor_adjacent_chemist_by_doctor}/${pDoctorId}`).pipe(map(response => response['Data']['ChemistList'] || []));
    }

    approveDoctor(pApproval: any): Observable<any> {
        return this.postData(Endpoints.doctor_approve, pApproval);
    }

    getDoctorList(pParameters: any): Observable<Doctor[]> {
        return this.postData(Endpoints.doctor_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDoctorApprove(pDoctorApproveRuleId: number): Observable<DoctorApproveRule> {
        return this.getData(`${Endpoints.doctor_approve_details}/${pDoctorApproveRuleId}`)
            .pipe(map(response => response['Data']['PaymentApprovalRule']));
    }

    getDoctorExport(pParameters: any): Observable<any> {
        return this.getData(Endpoints.export_doctor_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    saveDoctorApproveRule(pDoctorApproveRule: DoctorApproveRule): Observable<DoctorApproveRule> {
        return this.postData(pDoctorApproveRule.Id ? Endpoints.doctor_approve_edit : Endpoints.doctor_approve_add, pDoctorApproveRule);
    }

    deleteDoctorApproveRule(pDoctorApproveRuleId: number): Observable<any> {
        return this.deleteData(`${Endpoints.doctor_approve_delete}/${pDoctorApproveRuleId}`);
    }

    // setup
    getDegreeList(pParameters: any): Observable<Degree[]> {
        return this.postData(Endpoints.degree_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDegreeDetails(pDegreeId: number): Observable<Degree> {
        return this.getData(`${Endpoints.degree_details}/${pDegreeId}`).pipe(map(response => response['Data']['AcademicDegree']));
    }

    saveDegree(pDegree: Degree): Observable<any> {
        return this.postData(pDegree.Id ? Endpoints.degree_edit : Endpoints.degree_add, pDegree);
    }

    getDoctorDesignationList(pParameters: any): Observable<DoctorDesignation[]> {
        return this.postData(Endpoints.doctor_designation_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDoctorDesignationDetails(pDoctorDesignationId: number): Observable<DoctorDesignation> {
        return this.getData(`${Endpoints.doctor_designation_details}/${pDoctorDesignationId}`).pipe(map(response => response['Data']['DoctorDesignation']));
    }

    saveDoctorDesignation(pDoctorDesignation: DoctorDesignation): Observable<any> {
        return this.postData(pDoctorDesignation.Id ? Endpoints.doctor_designation_edit : Endpoints.doctor_designation_add, pDoctorDesignation);
    }

    getDoctorCategoryList(pParameters: any): Observable<DoctorCategory[]> {
        return this.postData(Endpoints.doctor_category_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDoctorCategoryDetails(pDoctorCategoryId: number): Observable<DoctorCategory> {
        return this.getData(`${Endpoints.doctor_category_details}/${pDoctorCategoryId}`).pipe(map(response => response['Data']['DoctorCategory']));
    }

    saveDoctorCategory(pDoctorCategory: DoctorCategory): Observable<any> {
        return this.postData(pDoctorCategory.Id ? Endpoints.doctor_category_edit : Endpoints.doctor_category_add, pDoctorCategory);
    }

    getChamberTypeList(pParameters: any): Observable<ChamberType[]> {
        return this.postData(Endpoints.chamber_type_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getChamberTypeDetails(pChamberTypeId: number): Observable<ChamberType> {
        return this.getData(`${Endpoints.chamber_type_details}/${pChamberTypeId}`).pipe(map(response => response['Data']['ChamberType']));
    }

    saveChamberType(pChamberType: ChamberType): Observable<any> {
        return this.postData(pChamberType.Id ? Endpoints.chamber_type_edit : Endpoints.chamber_type_add, pChamberType);
    }

    getPatientTypeList(pParameters: any): Observable<PatientType[]> {
        return this.postData(Endpoints.patient_type_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getPatientTypeDetails(pPatientTypeId: number): Observable<PatientType> {
        return this.getData(`${Endpoints.patient_type_details}/${pPatientTypeId}`).pipe(map(response => response['Data']['PatientType']));
    }

    savePatientType(pPatientType: PatientType): Observable<any> {
        return this.postData(pPatientType.Id ? Endpoints.patient_type_edit : Endpoints.patient_type_add, pPatientType);
    }

    getDoctorImageTypeList(pParameters: any): Observable<DoctorImageType[]> {
        return this.postData(Endpoints.doctor_image_type_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDoctorImageTypeDetails(pDoctorImageTypeId: number): Observable<DoctorImageType> {
        return this.getData(`${Endpoints.doctor_image_type_details}/${pDoctorImageTypeId}`).pipe(map(response => response['Data']['DoctorImageType']));
    }

    saveDoctorImageType(pDoctorImageType: DoctorImageType): Observable<any> {
        return this.postData(pDoctorImageType.Id ? Endpoints.doctor_image_type_edit : Endpoints.doctor_image_type_add, pDoctorImageType);
    }

    getSpecialityList(pParameters: any): Observable<Speciality[]> {
        return this.postData(Endpoints.speciality_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getSubSpecialityList(pParameters: any): Observable<SubSpeciality[]> {
        return this.postData(Endpoints.sub_speciality_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getSpecialityDetails(pSpecialityId: number): Observable<Speciality> {
        return this.getData(`${Endpoints.speciality_details}/${pSpecialityId}`).pipe(map(response => response['Data']['Speciality']));
    }

    saveSpeciality(pSpeciality: Speciality): Observable<any> {
        return this.postData(pSpeciality.Id ? Endpoints.speciality_edit : Endpoints.speciality_add, pSpeciality);
    }

    saveSubSpeciality(pSubSpeciality: SubSpeciality): Observable<any> {
        return this.postData(pSubSpeciality.Id ? Endpoints.sub_speciality_edit : Endpoints.sub_speciality_add, pSubSpeciality);
    }

    getSpecialDayList(pParameters: any): Observable<SpecialDay[]> {
        return this.postData(Endpoints.special_day_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getSpecialDayDetails(pSpecialDayId: number): Observable<SpecialDay> {
        return this.getData(`${Endpoints.special_day_details}/${pSpecialDayId}`).pipe(map(response => response['Data']['SpecialDay']));
    }

    saveSpecialDay(pSpecialDay: SpecialDay): Observable<any> {
        return this.postData(pSpecialDay.Id ? Endpoints.special_day_edit : Endpoints.special_day_add, pSpecialDay);
    }

    // survey doctor

    getSurveyDoctorDetails(pId: number): Observable<SurveyDoctor> {
        return this.getData(`${Endpoints.doctor_details}/${pId}`).pipe(map(response => response['Data']['Doctor']));
    }

    saveSurveyDoctor(pDoctor: SurveyDoctor): Observable<any> {
        return this.postData(Endpoints.survey_doctor_edit, pDoctor);
    }

    createSurveyDoctorFromDoctor(pDoctor: Doctor): Observable<any> {
        return this.postData(Endpoints.create_doctor_from_survey_doctor, pDoctor);
    }

    // doctor record

    getDoctorRecordDetails(pId: number): Observable<DoctorRecord> {
        return this.getData(`${Endpoints.doctor_record_details}/${pId}`).pipe(map(response => response['Data']['DoctorRecord']));
    }

    saveDoctorRecord(pDoctorRecord: DoctorRecord): Observable<any> {
        return this.postData(pDoctorRecord.Id ? Endpoints.doctor_record_edit : Endpoints.doctor_record_add, pDoctorRecord);
    }

    // doctor visit

    getDoctorVisitList(pParameters: any): Observable<DoctorVisit[]> {
        return this.postData(Endpoints.doctor_visit_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDoctorVisitDetails(pDoctorVisitId: number): Observable<DoctorVisit> {
        return this.getData(`${Endpoints.doctor_visit_details}/${pDoctorVisitId}`).pipe(map(response => response['Data']['DoctorVisit']));
    }

    saveDoctorVisit(pDoctorVisit: DoctorVisit): Observable<any> {
        return this.postData(pDoctorVisit.Id ? Endpoints.doctor_visit_edit : Endpoints.doctor_visit_add, pDoctorVisit);
    }

    approveDoctorVisitPlan(pParameters: any): Observable<any> {
        return this.postData(Endpoints.doctor_visit_plan_approve, pParameters);
    }

    getDoctorVisitPlanList(pParameters: any): Observable<DoctorVisitPlan[]> {
        return this.postData(Endpoints.doctor_visit_plan_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    approveDoctorVisit(pParameters: any): Observable<any> {
        return this.postData(Endpoints.doctor_visit_approve, pParameters);
    }

    approveBulkDoctorVisit(pApproval: Approval[]): Observable<any> {
        return this.postData(Endpoints.doctor_visit_bulk_approve, pApproval);
    }

    getDoctorVisitTypeList(pParameters: any): Observable<DoctorVisitType[]> {
        return this.postData(Endpoints.doctor_visit_type_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDoctorVisitTypeDetails(pDoctorVisitTypeId: number): Observable<DoctorVisitType> {
        return this.getData(`${Endpoints.doctor_visit_type_details}/${pDoctorVisitTypeId}`).pipe(map(response => response['Data']['DoctorVisitType']));
    }

    saveDoctorVisitType(pDoctorVisitType: DoctorVisitType): Observable<any> {
        return this.postData(pDoctorVisitType.Id ? Endpoints.doctor_visit_type_edit : Endpoints.doctor_visit_type_add, pDoctorVisitType);
    }

    uploadDoctorRecord(pDoctorRecordUpload: DoctorRecordUpload): Observable<any> {
        return this.postData(Endpoints.doctor_record_upload, pDoctorRecordUpload).pipe(map(response => response));
    }

    // doctor call

    approveVisit(pParameters: any): Observable<any> {
        return this.postData(Endpoints.visit_approve, pParameters);
    }

    saveVisitType(pVisitType: VisitType): Observable<VisitType> {
        return this.postData(pVisitType.Id ? Endpoints.visitType_edit : Endpoints.visitType_add, pVisitType);
    }

    saveVisit(pVisit: Visit): Observable<Visit> {
        return this.postData(pVisit.Id ? Endpoints.visit_edit : Endpoints.visit_add, pVisit);
    }

    getVisitTypeList(pParameters: any): Observable<VisitType[]> {
        return this.postData(Endpoints.visit_type_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getVisitDetails(pVisitId: number): Observable<Visit> {
        return this.getData(`${Endpoints.visit_details}/${pVisitId}`)
            .pipe(map(response => response['Data']['Visit']));
    }

    getVisitApprove(pVisitRuleId: number): Observable<VisitApproveRule> {
        return this.getData(`${Endpoints.visit_approve_details}/${pVisitRuleId}`)
            .pipe(map(response => response['Data']['PaymentApprovalRule']));
    }

    approveTourVisitPlan(pParameters: any): Observable<any> {
        return this.postData(Endpoints.tour_plan_approve, pParameters);
    }

    deleteVisitApproveRule(pVisitApproveRuleId: number): Observable<any> {
        return this.deleteData(`${Endpoints.visit_approve_delete}/${pVisitApproveRuleId}`);
    }

    getVisitType(pVisitTypeId: number): Observable<VisitType> {
        return this.getData(`${Endpoints.visitType_details}/${pVisitTypeId}`)
            .pipe(map(response => response['Data']['VisitType']));
    }

    saveVisitApproveRule(pVisitApproveRule: VisitApproveRule): Observable<VisitApproveRule> {
        return this.postData(pVisitApproveRule.Id ? Endpoints.visit_approve_edit : Endpoints.visit_approve_add, pVisitApproveRule);
    }

    // institute
    getInstituteList(pParameters: any): Observable<Institute[]> {
        return this.postData(Endpoints.institute_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getInstituteDetails(pInstituteId: number): Observable<Institute> {
        return this.getData(`${Endpoints.institute_details}/${pInstituteId}`).pipe(map(response => response['Data']['Institute']));
    }

    saveInstitute(pInstitute: Institute): Observable<any> {
        return this.postData(pInstitute.Id ? Endpoints.institute_edit : Endpoints.institute_add, pInstitute);
    }

    getInstituteTypeList(pParameters: any): Observable<InstituteType[]> {
        return this.postData(Endpoints.institute_type_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getInstituteTypeDetails(pInstituteTypeId: number): Observable<InstituteType> {
        return this.getData(`${Endpoints.institute_type_details}/${pInstituteTypeId}`).pipe(map(response => response['Data']['InstituteType']));
    }

    saveInstituteType(pInstituteType: InstituteType): Observable<any> {
        return this.postData(pInstituteType.Id ? Endpoints.institute_type_edit : Endpoints.institute_type_add, pInstituteType);
    }

    getDepartmentList(pParameters: any): Observable<Department[]> {
        return this.postData(Endpoints.department_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    saveDepartment(pSubSegment: Department): Observable<any> {
        return this.postData(pSubSegment.Id ? Endpoints.department_edit : Endpoints.department_add, pSubSegment);
    }

    getDepartmentDetails(pSiteTypeId: number): Observable<Department> {
        return this.getData(`${Endpoints.department_details}/${pSiteTypeId}`).pipe(map(response => response['Data']['InstituteDepartment']));
    }



    // product brand tag
    getProductBrandTagList(params: any, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.product_brand_tag_list, params).pipe(map(response => response['data']));
    }

    manageProductBrandTag(params: BrandTagManageDto, url: string): Observable<any> {
        return this.postDataForMicroService(url + (params.id ? Endpoints.product_brand_tag_edit : Endpoints.product_brand_tag_add), params).pipe(map(response => response['data']));
    }

    changeProductBrandTagStatus(params: any, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.product_brand_tag_status_activation, params).pipe(map(response => response));
    }

    // promotion

    saveSampleStockList(sampleStock: SampleStock): Observable<any> {
        return this.postData(sampleStock.Id ? Endpoints.sample_stock_edit : Endpoints.sample_stock_add, sampleStock);
    }

    transferSampleStock(pTransferSampleStock: TransferSampleStock): Observable<any> {
        return this.postData(Endpoints.transfer_sample_stock, pTransferSampleStock);
    }

    // prescription
    getPrescriptionTypeList(pParameters: any): Observable<PrescriptionType[]> {
        return this.postData(Endpoints.prescription_type_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getPrescriptionRejectReasonList(pParameters: any): Observable<RejectReason[]> {
        return this.postData(Endpoints.reject_reason_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getPrescriptionTypeDetails(pPrescriptionTypeId: number): Observable<PrescriptionType> {
        return this.getData(`${Endpoints.prescription_type_details}/${pPrescriptionTypeId}`).pipe(map(response => response['Data']['PrescriptionType']));
    }

    savePrescriptionType(pPrescriptionType: PrescriptionType): Observable<any> {
        return this.postData(pPrescriptionType.Id ? Endpoints.prescription_type_edit : Endpoints.prescription_type_add, pPrescriptionType);
    }

    saveRxRejectReasonType(pRejectReason: RejectReason): Observable<any> {
        return this.postData(pRejectReason.Id ? Endpoints.reject_reason_edit : Endpoints.reject_reason_add, pRejectReason);
    }

    getPrescriptionList(pParameters: any): Observable<Prescription[]> {
        return this.postData(Endpoints.prescription_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getRxProductiveReportTotal(pFilters: any): Observable<any> {
        return this.postData(Endpoints.rx_productive_report_total, pFilters).pipe(map(response => response['Data']));
    }

    getMarketWiseRxComparisonTotal(pFilters: any): Observable<any> {
        return this.postData(Endpoints.market_wise_rx_comparison_report_total, pFilters).pipe(map(response => response['Data']));
    }

    getPrescriptionDetails(pPrescriptionId: number): Observable<Prescription> {
        return this.getData(`${Endpoints.prescription_details}/${pPrescriptionId}`).pipe(map(response => response['Data']['Prescription']));
    }

    savePrescription(pPrescription: Prescription): Observable<any> {
        return this.postData(pPrescription.Id ? Endpoints.prescription_edit : Endpoints.prescription_add, pPrescription);
    }

    savePrescriptionApprovalRule(pPrescriptionApprovalRule: PrescriptionApproveRule): Observable<any> {
        return this.postData(Endpoints.add_prescription_approval_rule, pPrescriptionApprovalRule);
    }

    deletePrescriptionApprovalRule(pPrescriptionApproveRuleId: number): Observable<any> {
        return this.deleteData(`${Endpoints.delete_prescription_approval_rule}/${pPrescriptionApproveRuleId}`);
    }

    approvePrescription(pParameters: any): Observable<any> {
        return this.postData(Endpoints.prescription_approve, pParameters);
    }

    approvePrescriptionWithRxType(pParameters: any): Observable<any> {
        return this.postData(Endpoints.prescription_approve_with_rx_type, pParameters);
    }

    rejectPrescriptionWithReason(pParameters: any): Observable<any> {
        return this.postData(Endpoints.prescription_reject_with_reason, pParameters);
    }

    updateReason(pParameters: any): Observable<any> {
        return this.postData(Endpoints.update_reason, pParameters);
    }

    getCompetitorList(pParameters: any): Observable<Competitor[]> {
        return this.postData(Endpoints.competitor_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getCompetitorBrandList(pParameters: any): Observable<CompetitorBrand[]> {
        return this.postData(Endpoints.competitor_brand_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getCompetitorDetails(pCompetitorId: number): Observable<Competitor> {
        return this.getData(`${Endpoints.competitor_details}/${pCompetitorId}`).pipe(map(response => response['Data']['Competitor']));
    }

    saveCompetitor(pCompetitor: Competitor): Observable<any> {
        return this.postData(pCompetitor.Id ? Endpoints.competitor_edit : Endpoints.competitor_add, pCompetitor);
    }

    getCompetitorProductList(pParameters: any): Observable<CompetitorProduct[]> {
        return this.postData(Endpoints.competitor_product_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getCompetitorProductDetails(pCompetitorProductId: number): Observable<CompetitorProduct> {
        return this.getData(`${Endpoints.competitor_product_details}/${pCompetitorProductId}`).pipe(map(response => response['Data']['CompetitorProduct']));
    }

    getCompetitorBrandDetails(pCompetitorBrandId: number): Observable<CompetitorBrand> {
        return this.getData(`${Endpoints.competitor_brand_details}/${pCompetitorBrandId}`).pipe(map(response => response['Data']['CompetitorBrand']));
    }

    saveCompetitorProduct(pCompetitorProduct: CompetitorProduct): Observable<any> {
        return this.postData(pCompetitorProduct.Id ? Endpoints.competitor_product_edit : Endpoints.competitor_product_add, pCompetitorProduct);
    }

    saveCompetitorBrand(pCompetitorBrand: CompetitorBrand): Observable<any> {
        return this.postData(pCompetitorBrand.Id ? Endpoints.competitor_brand_edit : Endpoints.competitor_brand_add, pCompetitorBrand);
    }

    getSeenRx(pSeenRxId: number): Observable<SeenRx> {
        return this.getData(`${Endpoints.seen_rx_details}/${pSeenRxId}`)
            .pipe(map(response => response['Data']['SeenRx']));
    }

    saveSeenRX(pSeenRx: SeenRx): Observable<SeenRx> {
        return this.postData(pSeenRx.Id ? Endpoints.seen_rx_edit : Endpoints.seen_rx_add, pSeenRx);
    }

    approveSeenRX(pParameters: any): Observable<any> {
        return this.postData(Endpoints.seen_rx_approve, pParameters);
    }

    createRxForm(pRxFromList: RxForm): Observable<any> {
        return this.postData(Endpoints.create_rx_from, pRxFromList);
    }

    saveRxSurveyType(pSurvey: RxSurveyType): Observable<any> {
        return this.postData(pSurvey.Id ? Endpoints.rx_survey_type_edit : Endpoints.rx_survey_type_add, pSurvey);
    }

    approveRXSurvey(pParameters: any): Observable<any> {
        return this.postData(Endpoints.rx_survey_approve, pParameters);
    }

    saveRxSurvey(pRxSurvey: RxSurvey): Observable<RxSurvey> {
        return this.postData(Endpoints.rx_survey_edit, pRxSurvey);
    }

    getRXSurveyDetails(pId: number): Observable<RxSurvey> {
        return this.getData(`${Endpoints.rx_survey_details}/${pId}`)
            .pipe(map(response => response['Data']['RxSurvey']));
    }

    reportNonDuplicateRx(parameter: any): Observable<any> {
        return this.postData(Endpoints.non_duplicate_rx_remove, parameter).pipe(map(response => response['Data']['Id']));
    }

    /** Doctor & Institute Menu Ends*/

    /** Expense Claim Menu Starts */
    // expense claim
    approveExpenseClaim(pParameters: any): Observable<any> {
        return this.postData(Endpoints.expense_claim_approval, pParameters);
    }

    saveExpenseClaim(pExpenseclaim: Expenseclaim): Observable<Expenseclaim> {
        return this.postData(pExpenseclaim.Id ? Endpoints.expense_claim_edit : Endpoints.expense_claim_add, pExpenseclaim);
    }

    getExpenseClaimDetails(pExpenseClaimId: number): Observable<Expenseclaim> {
        return this.getData(`${Endpoints.expense_claim_details}/${pExpenseClaimId}`)
            .pipe(map(response => response['Data']['ExpenseClaim']));
    }

    getExpenseclaimApprove(pExpenseclaimRuleId: number): Observable<ExpenseclaimApproveRule> {
        return this.getData(`${Endpoints.expenseclaim_approve_details}/${pExpenseclaimRuleId}`)
            .pipe(map(response => response['Data']['PaymentApprovalRule']));
    }

    // setup
    getExpenseTypeList(pParameters: any): Observable<ExpenseType[]> {
        return this.postData(Endpoints.expense_type_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    saveExpenseType(pExpenseType: ExpenseType): Observable<ExpenseType> {
        return this.postData(pExpenseType.Id ? Endpoints.expense_type_edit : Endpoints.expense_type_add, pExpenseType);
    }

    getExpenseType(pExpenseTypeId: number): Observable<ExpenseType> {
        return this.getData(`${Endpoints.expense_type_details}/${pExpenseTypeId}`)
            .pipe(map(response => response['Data']['ExpenseType']));
    }

    deleteExpenseclaimApproveRule(pexpenseclaimApproveRuleId: number): Observable<any> {
        return this.deleteData(`${Endpoints.expenseclaim_approve_delete}/${pexpenseclaimApproveRuleId}`);
    }

    resetExpenseApproval(pId: number): Observable<any> {
        return this.getData(`${Endpoints.expense_claim_reset_approval}/${pId}`).pipe(map(response => response['Data']['Success']));
    }

    saveExpenseclaimApproveRule(pExpenseclaimApproveRule: ExpenseclaimApproveRule): Observable<ExpenseclaimApproveRule> {
        return this.postData(pExpenseclaimApproveRule.Id ? Endpoints.expenseclaim_approve_edit : Endpoints.expenseclaim_approve_add, pExpenseclaimApproveRule);
    }

    getTransportList(pParameters: any): Observable<Transport[]> {
        return this.postData(Endpoints.transport_method_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getransportMethod(pTransportId: number): Observable<Transport> {
        return this.getData(`${Endpoints.transport_method_details}/${pTransportId}`)
            .pipe(map(response => response['Data']['Transport']));
    }

    saveTransportMethod(pTransport: Transport): Observable<Transport> {
        return this.postData(pTransport.Id ? Endpoints.transport_method_edit : Endpoints.transport_method_add, pTransport);
    }

    getUserDistanceWiseTaDaRuleDetails(pTadaId: number): Observable<DistanceWiseTaDaRule> {
        return this.getData(`${Endpoints.user_distance_wise_ta_da_rule_details}/${pTadaId}`)
            .pipe(map(response => response['Data']['UserDistanceWiseTaDaRule']));
    }

    saveUserDistanceWiseTaDaRule(pTADAClaim: DistanceWiseTaDaRule): Observable<DistanceWiseTaDaRule> {
        return this.postData(pTADAClaim.Id ? Endpoints.user_distance_wise_ta_da_rule_upload : Endpoints.user_distance_wise_ta_da_rule_add, pTADAClaim);
    }

    deleteUserDistanceWiseTaDaRule(pId: number): Observable<any> {
        return this.deleteData(`${Endpoints.user_distance_wise_ta_da_rule_delete}/${pId}`);
    }

    deleteUserDistanceWiseTaDaRuleLocation(pUserId: number): Observable<any> {
        return this.deleteData(`${Endpoints.user_distance_wise_ta_da_rule_location_delete}/${pUserId}/${'removeUserLocation'}`);
    }

    uploadUserDistanceWiseTaDaRule(pParameters: any): Observable<any> {
        return this.postData(Endpoints.user_distance_wise_ta_da_rule_upload, pParameters).pipe(map(response => response['Data']));
    }

    saveDailyAllowanceApprovalRule(pApprovalRule: GeneralApprovalRule): Observable<any> {
        return this.postData(Endpoints.da_claim_approval_rule_add, pApprovalRule);
    }

    deleteDailyAllowanceApprovalRule(pApproveRuleId: number): Observable<any> {
        return this.deleteData(`${Endpoints.da_claim_approval_rule_delete}/${pApproveRuleId}`);
    }

    saveMonthlyAllowanceApprovalRule(pApprovalRule: GeneralApprovalRule): Observable<any> {
        return this.postData(Endpoints.ma_claim_approval_rule_add, pApprovalRule);
    }

    deleteMonthlyAllowanceApprovalRule(pApproveRuleId: number): Observable<any> {
        return this.deleteData(`${Endpoints.ma_claim_approval_rule_delete}/${pApproveRuleId}`);
    }

    // monthly allowance
    saveAllowance(pAllowance: MonthlyAllowance): Observable<MonthlyAllowance> {
        return this.postData(pAllowance.Id ? Endpoints.monthlyAllowance_edit : Endpoints.monthlyAllowance_add, pAllowance);
    }

    getAllowance(pAllowanceId: number): Observable<MonthlyAllowance> {
        return this.getData(`${Endpoints.monthlyAllowance_details}/${pAllowanceId}`)
            .pipe(map(response => response['Data']['MonthlyAllowance']));
    }

    getAllowanceList(pParameters: any): Observable<MonthlyAllowance[]> {
        return this.postData(Endpoints.monthlyAllowance_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    // daily allowance
    resetTaDaApproval(pId: number): Observable<any> {
        return this.getData(`${Endpoints.ta_da_claim_reset_approval}/${pId}`).pipe(map(response => response['Data']['Success']));
    }

    approveTadaClaim(pParameters: any): Observable<any> {
        return this.postData(Endpoints.ta_da_claim_approve, pParameters);
    }

    getTadaMarketRuleDetails(pTadaMarketRuleId: number): Observable<TadaMarketRule> {
        return this.getData(`${Endpoints.taDaMarketRule_details}/${pTadaMarketRuleId}`)
            .pipe(map(response => response['Data']['TaDaMarketRule']));
    }

    getTadaClaimDetails(pTadaClaimId: number): Observable<TadaClaim> {
        return this.getData(`${Endpoints.ta_da_claim_details}/${pTadaClaimId}`)
            .pipe(map(response => response['Data']['TaDaClaim']));
    }

    saveTaDaClaimApproveRule(pTaDaApproveRule: TaDaApprovalRule): Observable<TaDaApprovalRule> {
        return this.postData(pTaDaApproveRule.Id ? Endpoints.ta_da_claim_approve_edit : Endpoints.ta_da_claim_approve_add, pTaDaApproveRule);
    }

    saveTadaMarketRule(pTadaMarketRule: TadaMarketRule): Observable<TadaMarketRule> {
        return this.postData(pTadaMarketRule.Id ? Endpoints.taDaMarketRule_edit : Endpoints.taDaMarketRule_add, pTadaMarketRule);
    }

    saveTADAClaim(pTADAClaim: TadaClaim): Observable<TadaClaim> {
        return this.postData(pTADAClaim.Id ? Endpoints.ta_da_claim_edit : Endpoints.ta_da_claim_add, pTADAClaim);
    }

    getRoleWiseDailyAllowanceDetails(pId: number, pURL: string): Observable<RoleWiseDailyAllowanceDetails> {
        return this.getDataForMicroService(pURL + `${Endpoints.role_wise_daily_allowances_details}?id=${pId}`).pipe(map(response => response['data']));
    }

    saveRoleWiseDailyAllowance(pFlatRate: RoleWiseDailyAllowance, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.role_wise_daily_allowances_add, pFlatRate).pipe(map(response => response));
    }

    updateRoleWiseDailyAllowance(pId: any, pAllowance: number, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + `${Endpoints.role_wise_daily_allowances_update}?id=${pId}&allowance=${pAllowance}`).pipe(map(response => response));
    }

    deleteRoleWiseDailyAllowance(pId: number, pURL: string): Observable<any> {
        return this.deleteDataForMicroService(pURL + `${Endpoints.role_wise_daily_allowances_delete}/${pId}`);
    }

    inactiveRoleWiseDailyAllowance(pId: number, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + `${Endpoints.role_wise_daily_allowances_inactive}/${pId}`);
    }

    getVehicleDetails(pId: number, pURL: string): Observable<VehicleDetails> {
        return this.postDataForMicroService(pURL + `${Endpoints.user_vehicle_details}/${pId}`).pipe(map(response => response['data']));
    }

    saveVehicle(pVehicle: VehicleRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.user_vehicle_add, pVehicle).pipe(map(response => response));
    }

    getVehicleDetailsByUserId(pId: number, pURL: string): Observable<VehicleDetails> {
        return this.getDataForMicroService(pURL + `${Endpoints.user_vehicle_details_by_user_Id}/${pId}`).pipe(map(response => response['data']));
    }

    getVehicleListByUserId(pId: number, pURL: string): Observable<VehicleDetails> {
        return this.postDataForMicroService(pURL + `${Endpoints.user_vehicle_list_by_user_Id}/${pId}`).pipe(map(response => response['data']));
    }

    inactiveVehicle(pId: number, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + `${Endpoints.user_vehicle_inactive}/${pId}`);
    }

    updateVehicle(pVehicle: VehicleRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.user_vehicle_update, pVehicle).pipe(map(response => response));
    }

    // mileage
    approveMileage(pParameters: any): Observable<any> {
        return this.postData(Endpoints.mileageClaim_approve, pParameters);
    }

    saveMilageClaim(pMilageClaim: MilageClaim): Observable<MilageClaim> {
        return this.postData(pMilageClaim.Id ? Endpoints.mileageClaim_edit : Endpoints.mileageClaim_add, pMilageClaim);
    }

    getMilageClaimDetails(pMilageClaimId: number): Observable<MilageClaim> {
        return this.getData(`${Endpoints.mileageClaim_details}/${pMilageClaimId}`)
            .pipe(map(response => response['Data']['MileageClaim']));
    }

    resetMileageApproval(pId: number): Observable<any> {
        return this.getData(`${Endpoints.mileageClaim__reset_approval}/${pId}`).pipe(map(response => response['Data']['Success']));
    }

    /** Expense Claim Menu Ends */


    /** HR Menu Starts */

    // attendance

    getAttendanceList(pParameters: any): Observable<Attendance[]> {
        return this.postData(Endpoints.attendance_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    saveAttendance(pAttendance: Attendance): Observable<any> {
        return this.postData(pAttendance.Id ? Endpoints.attendance_edit : Endpoints.attendance_add, pAttendance);
    }

    resetAttendance(pAttendance: Attendance): Observable<any> {
        return this.postData(Endpoints.attendance_reset, pAttendance);
    }

    getPresentAbsentTotalCount(pFilters: any): Observable<any> {
        return this.postData(Endpoints.present_absent_report_total_count, pFilters).pipe(map(response => response['Data']));
    }

    // leave
    getLeaveTypeList(pParameters: any): Observable<LeaveType[]> {
        return this.postData(Endpoints.leave_type_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getLeaveTypeDetails(pLeaveTypeId: number): Observable<LeaveType> {
        return this.getData(`${Endpoints.leave_type_details}/${pLeaveTypeId}`).pipe(map(response => response['Data']['LeaveType']));
    }

    saveLeaveType(pLeaveType: LeaveType): Observable<any> {
        return this.postData(pLeaveType.Id ? Endpoints.leave_type_edit : Endpoints.leave_type_add, pLeaveType);
    }

    getLeaveAllocationList(pParameters: any): Observable<LeaveAllocation[]> {
        return this.postData(Endpoints.leave_allocation_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getLeaveAllocationDetails(pLeaveAllocationId: number): Observable<LeaveAllocation> {
        return this.getData(`${Endpoints.leave_allocation_details}/${pLeaveAllocationId}`).pipe(map(response => response['Data']['LeaveAllocation']));
    }

    saveLeaveAllocation(pLeaveAllocation: LeaveAllocation): Observable<any> {
        return this.postData(pLeaveAllocation.Id ? Endpoints.leave_allocation_edit : Endpoints.leave_allocation_add, pLeaveAllocation);
    }

    saveMultipleLeave(pMultipleLeave: MultipleLeave): Observable<any> {
        return this.postData(Endpoints.multiple_leave_add, pMultipleLeave);
    }

    getLeaveDatesOfUser(pUserId: number, pYear: number): Observable<any> {
        return this.getData(`${Endpoints.user_leave_dates}/${pUserId}` + '?' + ('access_token=' + this.accessToken + '&') + 'Year=' + pYear).pipe(map(response => response['Data']['content']));
    }

    getLeaveApprove(pLeaveRuleId: number): Observable<UserLeaveApproveRule> {
        return this.getData(`${Endpoints.userleave_approve_details}/${pLeaveRuleId}`)
            .pipe(map(response => response['Data']['PaymentApprovalRule']));
    }

    deleteLeaveApproveRule(pLeaveApproveRuleId: number): Observable<any> {
        return this.deleteData(`${Endpoints.userleave_approve_delete}/${pLeaveApproveRuleId}`);
    }

    saveLeaveAccount(pLeaveAccount: LeaveAccount): Observable<any> {
        return this.postData(Endpoints.leave_account_manage, pLeaveAccount);
    }

    getUserLeaveList(pParameters: any): Observable<UserLeave[]> {
        return this.postData(Endpoints.user_leave_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getUserLeaveDetails(pUserLeaveId: number): Observable<UserLeave> {
        return this.getData(`${Endpoints.user_leave_details}/${pUserLeaveId}`).pipe(map(response => response['Data']['UserLeave']));
    }

    saveUserLeave(pUserLeave: UserLeave): Observable<any> {
        return this.postData(pUserLeave.Id ? Endpoints.user_leave_edit : Endpoints.user_leave_add, pUserLeave);
    }

    getLeaveAccountList(pParameters: any): Observable<LeaveAccount[]> {
        return this.postData(Endpoints.leave_account_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getLeaveReport(pParameters: any): Observable<UserLeaveAccount[]> {
        return this.postData(Endpoints.user_leave_account, pParameters).pipe(map(response => response['Data']['content']));
    }

    saveLeaveApproveRule(pLeaveApproveRule: UserLeaveApproveRule): Observable<UserLeaveApproveRule> {
        return this.postData(pLeaveApproveRule.Id ? Endpoints.userleave_approve_edit : Endpoints.userleave_approve_add, pLeaveApproveRule);
    }

    // hr setup

    getHolidayList(pParameters: any): Observable<Holiday[]> {
        return this.postData(Endpoints.holiday_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getHolidayDetails(pHolidayId: number): Observable<Holiday> {
        return this.getData(`${Endpoints.holiday_details}/${pHolidayId}`).pipe(map(response => response['Data']['Holiday']));
    }

    saveHoliday(pHoliday: Holiday): Observable<any> {
        return this.postData(pHoliday.Id ? Endpoints.holiday_edit : Endpoints.holiday_add, pHoliday);
    }

    setWeekendForUser(pWeekend: Weekend): Observable<any> {
        return this.postData(pWeekend.Id ? Endpoints.edit_weekend_request : Endpoints.set_weekend_request, pWeekend);
    }

    approveWeekendRequest(pApproval: Approval): Observable<any> {
        return this.postData(Endpoints.approve_weekend_request, pApproval);
    }

    getDailyShiftList(pParameters: any): Observable<DailyShift[]> {
        return this.postData(Endpoints.daily_shift_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDailyShiftDetails(pDailyShiftId: number): Observable<DailyShift> {
        return this.getData(`${Endpoints.daily_shift_details}/${pDailyShiftId}`).pipe(map(response => response['Data']['DailyShift']));
    }

    saveDailyShift(pDailyShift: DailyShift): Observable<any> {
        return this.postData(pDailyShift.Id ? Endpoints.daily_shift_edit : Endpoints.daily_shift_add, pDailyShift);
    }

    // notice board
    getNoticeDetails(pId: number): Observable<NoticeBoard> {
        return this.getData(`${Endpoints.notice_details}/${pId}`).pipe(map(response => response['Data']['NoticeBoard']));
    }

    saveNoticeBoard(pNoticeBoard: NoticeBoard): Observable<NoticeBoard> {
        return this.postData(pNoticeBoard.Id ? Endpoints.notice_edit : Endpoints.notice_add, pNoticeBoard);
    }

    changeNoticeBoardActiveStatus(pManage: any): Observable<any> {
        return this.postData(Endpoints.update_notice_board_active_status, pManage).pipe(map(response => response));
    }

    // training
    getTrainingDetails(pId: number): Observable<Training> {
        return this.getData(`${Endpoints.training_details}/${pId}`).pipe(map(response => response['Data']['Training']));
    }

    saveTraining(pTraining: Training): Observable<Training> {
        return this.postData(pTraining.Id ? Endpoints.training_edit : Endpoints.training_add, pTraining);
    }

    saveTrainingComment(pTraining: TrainingComment): Observable<TrainingComment> {
        return this.postData(Endpoints.training_comment, pTraining);
    }

    // exam
    getExamDetails(pId: number): Observable<Surveyy> {
        return this.getData(`${Endpoints.exam_details}/${pId}`).pipe(map(response => response['Data']['Survey']));
    }

    deleteExam(pId: number): Observable<any> {
        return this.deleteData(`${Endpoints.delete_exam}/${pId}`);
    }

    getSurveyResponseDetails(pId: number): Observable<SurveyResponse> {
        return this.getData(`${Endpoints.survey_response_details}/${pId}`).pipe(map(response => response['Data']['SurveyRespondent']));
    }

    getExamResponseDetails(pId: number): Observable<SurveyResponse> {
        return this.getData(`${Endpoints.exam_response_details}/${pId}`).pipe(map(response => response['Data']['SurveyRespondent']));
    }

    saveExamEvaluation(pSurvey: SurveyResponse): Observable<SurveyResponse> {
        return this.postData(Endpoints.exam_evaluation_save, pSurvey);
    }

    saveExam(pSurvey: Surveyy): Observable<Surveyy> {
        return this.postData(pSurvey.Id ? Endpoints.exam_edit : Endpoints.exam_add, pSurvey);
    }

    // exam v2
    createExam(pExam: Exam, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.exam_create, pExam).pipe(map(response => response['Data']['Value']));
    }

    updateExam(pExam: Exam, pURL: string): Observable<any> {
        return this.putDataForMicroService(pURL + Endpoints.exam_update, pExam).pipe(map(response => response['Data']['Value']));
    }

    getExam(pExamId: number, pURL: string): Observable<Exam> {
        return this.getDataForMicroService(pURL + `${Endpoints.exam_info}/${pExamId}`).pipe(map(response => response['Data']['Value']));
    }

    getQuestion(pExamId: number, pURL: string): Observable<ExamQuestion[]> {
        return this.getDataForMicroService(pURL + `${Endpoints.question_info}/${pExamId}`).pipe(map(response => response['Data']['content']));
    }

    setQuestions(pExamQuestion: any, pURL: string): Observable<any> {
        return this.putDataForMicroService(pURL + Endpoints.set_questions, pExamQuestion);
    }

    getAttendedAbsentPassedCount(pExamId: number, pURL: string): Observable<any> {
        return this.getDataForMicroService(pURL + Endpoints.attended_absent_passed_count, { ExamId: pExamId }).pipe(map(response => response['Data']['Value']));
    }

    getAnswerPaper(pAnswerPaperId: number, pURL: string): Observable<AnswerPaper> {
        return this.getDataForMicroService(pURL + Endpoints.exam_answer_paper, { AnswerPaperId: pAnswerPaperId }).pipe(map(response => response['Data']['Value']));
    }

    evaluateExam(pExamId, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.evaluate_exam, pExamId).pipe(map(response => response['Data']['Value']));
    }

    getExamList(params, url: string): Observable<Exam[]> {
        return this.getDataForMicroService(url + Endpoints.exam_list_v2, params).pipe(map(response => response['Data']['content']));
    }

    /** HR Menu Ends */

    /** KPI Menu Starts */

    // target achievement
    getMarketTarget(pParameters: any): Observable<any> {
        return this.postData(Endpoints.market_target_count, pParameters).pipe(map(response => response['Data']));
    }

    getMarketWiseTargetDetails(pTargetId: number): Observable<MarketSalesTarget> {
        return this.getData(`${Endpoints.market_sales_target_details}/${pTargetId}`).pipe(map(response => response['Data']['MarketSalesTarget']));
    }

    getDailyTargetAchievementDetails(pTargetId: number): Observable<DailyTargetAchievement> {
        return this.getData(`${Endpoints.daily_sales_target_details}/${pTargetId}`).pipe(map(response => response['Data']['DailySalesTarget']));
    }

    saveUserRxMonthlyTarget(pTarget: UserMonthlyRxTarget): Observable<any> {
        return this.postData((pTarget.Id) ? Endpoints.user_rx_target_edit : Endpoints.user_rx_target_add, pTarget);
    }

    saveUserRxMonthlyTargetAndCount(pTarget: UserRxMonthlyTargetAndCount): Observable<any> {
        return this.postData((pTarget.TargetId) ? Endpoints.user_rx_target_edit : Endpoints.user_rx_target_add, pTarget);
    }

    saveMarketWiseTarget(pTarget: MarketSalesTarget): Observable<any> {
        return this.postData(pTarget.Id ? Endpoints.market_sales_target_edit : Endpoints.market_sales_target_add, pTarget);
    }

    uploadMarketSalesTarget(pTarget: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.market_sales_target_upload, pTarget).pipe(map(response => response));
    }

    addMarketSalesTarget(pData: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.market_wise_sales_target_add, pData).pipe(map(response => response));
    }
    setDailySalesTarget(pTarget: DailyTargetAchievement): Observable<any> {
        return this.postData(pTarget.Id ? Endpoints.daily_sales_target_add : Endpoints.daily_sales_target_set, pTarget);
    }

    editDailySalesTarget(pTarget: DailyTargetAchievement): Observable<any> {
        return this.postData(Endpoints.daily_sales_target_edit, pTarget);
    }

    getProductWiseTargetDetails(pTargetId: number): Observable<MarketProductSalesTarget> {
        return this.getData(`${Endpoints.product_sales_target_details}/${pTargetId}`).pipe(map(response => response['Data']['MarketSalesTarget']));
    }

    saveProductWiseTarget(pTarget: MarketProductSalesTarget): Observable<any> {
        return this.postData(pTarget.Id ? Endpoints.product_sales_target_edit : Endpoints.product_sales_target_add, pTarget);
    }

    getMarketWiseSalesTargetListMarketHierarchy(pParameters: any, pURL: string): Observable<MarketWiseTargetMarketHierarchyRes[]> {
        return this.postDataForMicroService(pURL + Endpoints.market_wise_sales_target_list_market_hierarchy, pParameters).pipe(map(response => response['data']));
    }

    getMarketProductWiseTarget(pParameters: any, pUrl: string): Observable<any> {
        return this.postDataForMicroService(pUrl + Endpoints.product_sales_target_list, pParameters).pipe(map(response => response['data']));
    }

    getMarketProductWiseTargetListMarketHierarchy(pParameters: any, pURL: string): Observable<MarketProductListMarketDto[]> {
        return this.postDataForMicroService(pURL + Endpoints.market_wise_product_sales_market_hierarchy, pParameters).pipe(map(response => response['data']));
    }

    saveMarketProductSalesTarget(pParameters: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.market_product_sales_target_add, pParameters).pipe(map(response => response['data']));
    }

    deleteMarketProductSalesTarget(params: string, pURL: string): Observable<any> {
        return this.deleteDataForMicroService(`${pURL}${Endpoints.market_product_sales_target_delete}${params}`).pipe(map(response => response));
    }

    downloadMarketProductSalesTargetTemplate(pParameters: any, pURL: string): Observable<any> {
        return this.getDataForMicroService(pURL + Endpoints.download_market_wise_sales_target_template, pParameters).pipe(map(response => response['data']));
    }

    uploadMarketProductSalesTargetTemplate(pParameters: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.upload_market_wise_sales_target_template, pParameters).pipe(map(response => response['data']));
    }

    uploadMarketProductSalesTarget(pParameters: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.market_product_sales_target_upload, pParameters).pipe(map(response => response['data']));
    }

    getMarketProductWiseTargetAchievement(pParameters: any, pUrl: string): Observable<any> {
        return this.postDataForMicroService(pUrl + Endpoints.market_product_target_achievement_list, pParameters).pipe(map(response => response['data']));
    }

    getMarketProductWiseTargetAchievementListMarketHierarchy(pParameters: any, pURL: string): Observable<MarketProductListMarketDto[]> {
        return this.postDataForMicroService(pURL + Endpoints.market_product_target_achievement_market_hierarchy, pParameters).pipe(map(response => response['data']));
    }



    /** KPI Menu Ends */

    /** Location Menu Starts */

    getUserLocationList(pParameters: any): Observable<TrackingLocation[]> {
        return this.postData(Endpoints.user_location_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getUserLocationListV2(pParameters: any): Observable<TrackingLocation[]> {
        return this.postData(Endpoints.user_location_list_v2, pParameters).pipe(map(response => response['Data']['content']));
    }

    getUserLastLocationList(pParameters: any): Observable<TrackingLocation[]> {
        return this.postData(Endpoints.user_last_location_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getUserLastLocationListV2(pParameters: any): Observable<TrackingLocation[]> {
        return this.postData(Endpoints.user_last_location_list_v2, pParameters).pipe(map(response => response['Data']['content']));
    }

    getDoctorVisitLocations(pParameters: any): Observable<DoctorVisitLocations[]> {
        return this.postData(Endpoints.doctor_visit_locations, pParameters).pipe(map(response => response['Data']['content']));
    }

    getChemistAndDoctorLocationList(pParameters: any): Observable<TrackingLocation[]> {
        return this.postData(Endpoints.chemist_doctor_location, pParameters).pipe(map(response => response['Data']['content']));
    }

    deleteUserLocation(pUserId: number): Observable<any> {
        return this.deleteData(`${Endpoints.user_location_delete}/${pUserId}`);
    }

    getUserLastLocations(pParameters, pUrl: string): Observable<UserLastLocations[]> {
        return this.postDataForMicroService(pUrl + Endpoints.user_last_locations, pParameters).pipe(map(response => response['data']['content']));
    }

    getUserTimelineByDate(pParameters, pUrl: string): Observable<UserTimeLineByDate[]> {
        return this.postDataForMicroService(pUrl + Endpoints.user_timeline_by_date, pParameters).pipe(map(response => response['data']['content']));
    }

    getUserTimelineByDateRange(pParameters, pUrl: string): Observable<any[]> {
        return this.postDataForMicroService(pUrl + Endpoints.user_timeline_by_date_range, pParameters).pipe(map(response => response['data']['content']));
    }

    getEventList(pParameters, pUrl: string): Observable<any> {
        return this.postDataForMicroService(pUrl + Endpoints.event_list, pParameters).pipe(map(response => response['data']));
    }

    /** Location Menu Ends */

    /** Others Menu Starts */

    // contact
    getContactTypeList(pParameters: any): Observable<ContactType[]> {
        return this.postData(Endpoints.contact_type_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getContactTypeDetails(pContactTypeId: number): Observable<ContactType> {
        return this.getData(`${Endpoints.contact_type_details}/${pContactTypeId}`).pipe(map(response => response['Data']['ContactType']));
    }

    saveContactType(pContactType: ContactType): Observable<any> {
        return this.postData(pContactType.Id ? Endpoints.contact_type_edit : Endpoints.contact_type_add, pContactType);
    }

    // segment
    getSegmentList(pParameters: any): Observable<Segment[]> {
        return this.postData(Endpoints.segment_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    saveSegment(pSegment: Segment): Observable<any> {
        return this.postData(pSegment.Id ? Endpoints.segment_edit : Endpoints.segment_add, pSegment);
    }

    getSegmentDetails(pSegmentId: number): Observable<Segment> {
        return this.getData(`${Endpoints.segment_details}/${pSegmentId}`).pipe(map(response => response['Data']['Segment']));
    }

    getSegmentListForReports(pParameters: any): Observable<Segment[]> {
        return this.postData(Endpoints.segment_list, pParameters).pipe(map(response => this.segmentsForReports = response['Data']['content']));
    }

    // sub-segment
    getSubSegmentList(pParameters: any): Observable<SubSegment[]> {
        return this.postData(Endpoints.sub_segment_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getProductDoseList(pParameters: any): Observable<ProductDose[]> {
        return this.postData(Endpoints.product_dose_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getSubSegmentDetails(pSubSegmentId: number): Observable<SubSegment> {
        return this.getData(`${Endpoints.sub_segment_details}/${pSubSegmentId}`).pipe(map(response => response['Data']['SubSegment']));
    }

    saveSubSegment(pSubSegment: SubSegment): Observable<any> {
        return this.postData(pSubSegment.Id ? Endpoints.sub_segment_edit : Endpoints.sub_segment_add, pSubSegment);
    }

    /** Others Menu Ends */

    /** Product Menu Starts */

    getProductList(pParameters: any): Observable<Product[]> {
        return this.postData(Endpoints.product_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getProductDetails(pProductId: number): Observable<Product> {
        return this.getData(`${Endpoints.product_details}/${pProductId}`).pipe(map(response => response['Data']['Product']));
    }

    saveProduct(pProduct: Product): Observable<any> {
        return this.postData(pProduct.Id ? Endpoints.product_edit : Endpoints.product_add, pProduct);
    }

    saveFocusBrand(pBrand: FocusBrand): Observable<any> {
        return this.postData(pBrand.Id ? Endpoints.focus_brand_edit : Endpoints.focus_brand_add, pBrand);
    }

    deleteFocusBrand(pDeviceId: number): Observable<any> {
        return this.deleteData(`${Endpoints.delete_focus_brand}/${pDeviceId}`);
    }

    editFocusBrand(pDeviceId: number): Observable<any> {
        return this.deleteData(`${Endpoints.focus_brand_edit}/${pDeviceId}`);
    }

    getFocusBrandDetails(pId: number): Observable<FocusBrand> {
        return this.getData(`${Endpoints.focus_brand_details}/${pId}`).pipe(map(response => response['Data']['content']));
    }

    getProductLineList(pParameters: any): Observable<ProductLine[]> {
        return this.postData(Endpoints.product_line_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getProductLineDetails(pProductLineId: number): Observable<ProductLine> {
        return this.getData(`${Endpoints.product_line_details}/${pProductLineId}`).pipe(map(response => response['Data']['ProductLine']));
    }

    saveProductLine(pProductLine: ProductLine): Observable<any> {
        return this.postData(pProductLine.Id ? Endpoints.product_line_edit : Endpoints.product_line_add, pProductLine);
    }

    getProductBrandList(pParameters: any): Observable<ProductBrand[]> {
        return this.postData(Endpoints.product_brand_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getProductBrandDetails(pProductBrandId: number): Observable<ProductBrand> {
        return this.getData(`${Endpoints.product_brand_details}/${pProductBrandId}`).pipe(map(response => response['Data']['ProductBrand']));
    }

    saveProductBrand(pProductBrand: ProductBrand): Observable<any> {
        return this.postData(pProductBrand.Id ? Endpoints.product_brand_edit : Endpoints.product_brand_add, pProductBrand);
    }

    saveProductBrand_v2(pProductBrand: ProductBrandManagementDto, url: string): Observable<any> {
        return this.postDataForMicroService(url + (pProductBrand.id ? Endpoints.product_brand_edit_v2 : Endpoints.product_brand_add_v2), pProductBrand);
    }

    getProductBrandDetailedList(params: any, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.product_brand_detailed_list, params).pipe(map(response => response['data']));
    }

    changeProductBrandStatus(params: any, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.product_brand_status_activation, params).pipe(map(response => response));
    }

    getProductBrandDetail(params: any, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.product_brand_detail, params).pipe(map(response => response['data']));
    }

    getProductTypeList(pParameters: any): Observable<ProductType[]> {
        return this.postData(Endpoints.product_type_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getProductTypeDetails(pProductTypeId: number): Observable<ProductType> {
        return this.getData(`${Endpoints.product_type_details}/${pProductTypeId}`).pipe(map(response => response['Data']['ProductType']));
    }

    saveProductType(pProductType: ProductType): Observable<any> {
        return this.postData(pProductType.Id ? Endpoints.product_type_edit : Endpoints.product_type_add, pProductType);
    }

    updateExpectedProduct(pParameters: any): Observable<any> {
        return this.postData(Endpoints.update_expected_product, pParameters);
    }

    saveProductDose(pSpeciality: Speciality): Observable<any> {
        return this.postData(pSpeciality.Id ? Endpoints.product_dose_edit : Endpoints.product_dose_add, pSpeciality);
    }

    deleteExpectedProduct(pExpectedProductId: number): Observable<any> {
        return this.deleteData(`${Endpoints.doctor_expected_product_delete}/${pExpectedProductId}`);
    }

    getExpectedProductsByDoctor(pDoctorId: number): Observable<ExpectedProduct[]> {
        return this.getData(`${Endpoints.expected_product_list_by_doctor}/${pDoctorId}` + '?' + ('access_token=' + this.accessToken)).pipe(map(response => response['Data']['content']));
    }

    saveExpectedProduct(pExpectedProduct: ExpectedProduct): Observable<any> {
        return this.postData(pExpectedProduct.Id ? Endpoints.doctor_expected_product_edit : Endpoints.doctor_expected_product_add, pExpectedProduct);
    }

    saveProductPriceDetailsList(pproductPrice: ProductPrice): Observable<any> {
        return this.postData(Endpoints.product_price_details_updateProductPrice, pproductPrice);
    }

    deleteProductPriceDetailsList(dproductPrice: ProductPrice): Observable<any> {
        return this.postData(Endpoints.product_price_details_updateProductPrice, dproductPrice);
    }

    getPriceListDetails(pProductPriceId: number): Observable<any> {
        return this.getData(`${Endpoints.product_price_list_details}/${pProductPriceId}`).pipe(map(response => response['Data']['ProductPriceList']));
    }

    saveProductPriceList(productPrice: ProductPrice): Observable<any> {
        return this.postData(productPrice.Id ? Endpoints.product_price_edit : Endpoints.product_price_add, productPrice);
    }

    getpriceList(pParameters: any): Observable<ProductPrice[]> {
        return this.postData(Endpoints.product_price_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getProductPriceList(pParameters: any): Observable<ProductPrice[]> {
        return this.postData(Endpoints.product_price_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getTherapeuticGroupList(pParameters: any): Observable<TherapeuticGroup[]> {
        return this.postData(Endpoints.therapeutic_group_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getTherapeuticGroupDetails(pTherapeuticGroupId: number): Observable<TherapeuticGroup> {
        return this.getData(`${Endpoints.therapeutic_group_details}/${pTherapeuticGroupId}`).pipe(map(response => response['Data']['TherapeuticGroup']));
    }

    saveTherapeuticGroup(pTherapeuticGroup: TherapeuticGroup): Observable<any> {
        return this.postData(pTherapeuticGroup.Id ? Endpoints.therapeutic_group_edit : Endpoints.therapeutic_group_add, pTherapeuticGroup);
    }

    getGenericGroupList(pParameters: any): Observable<GenericGroup[]> {
        return this.postData(Endpoints.generic_group_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getGenericGroupDetails(pGenericGroupId: number): Observable<GenericGroup> {
        return this.getData(`${Endpoints.generic_group_details}/${pGenericGroupId}`).pipe(map(response => response['Data']['GenericGroup']));
    }

    saveGenericGroup(pGenericGroup: GenericGroup): Observable<any> {
        return this.postData(pGenericGroup.Id ? Endpoints.generic_group_edit : Endpoints.generic_group_add, pGenericGroup);
    }

    getProductAndCompetitorProductList(pParameters: any): Observable<Product[]> {
        return this.postData(Endpoints.product_and_competitor_product_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getMinifiedProductList(pParameters: any): Observable<MinifiedProduct[]> {
        return this.postData(Endpoints.minified_product_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getSampleGiftChallanProducts(pParameters: any, url: string): Observable<SampleGiftChallanProduct[]> {
        return this.postDataForMicroService(url + Endpoints.product_list_for_filter, pParameters)
            .pipe(map(response => response.data.content));
    }

    /** Product Menu Ends */


    /** Sales & Collection Menu Starts */

    // order

    approveOrder(pParameters: any): Observable<any> {
        return this.postData(Endpoints.order_approve, pParameters);
    }

    saveOrder(pOrder: Order): Observable<any> {
        return this.postData(pOrder.Id ? Endpoints.order_edit : Endpoints.order_add, pOrder);
    }

    getOrderList(pParameters: any): Observable<Order[]> {
        return this.postData(Endpoints.order_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getOrderDetails(pId: number): Observable<Order> {
        return this.getData(`${Endpoints.order_details}/${pId}`).pipe(map(response => response['Data']['Order']));
    }

    getOrderApprove(pPaymentOrderRuleId: number): Observable<OrderApproveRule> {
        return this.getData(`${Endpoints.order_approve_details}/${pPaymentOrderRuleId}`)
            .pipe(map(response => response['Data']['PaymentApprovalRule']));
    }

    resetOrderApproval(pId: number): Observable<any> {
        return this.getData(`${Endpoints.order__reset_approval}/${pId}`).pipe(map(response => response['Data']['Success']));
    }

    deleteOrderApproveRule(pOrderApproveRuleId: number): Observable<any> {
        return this.deleteData(`${Endpoints.order_approve_delete}/${pOrderApproveRuleId}`);
    }

    saveOrderApproveRule(pOrderApproveRule: OrderApproveRule): Observable<OrderApproveRule> {
        return this.postData(pOrderApproveRule.Id ? Endpoints.order_approve_edit : Endpoints.order_approve_add, pOrderApproveRule);
    }

    getDoctorOrderDetails(pId: number): Observable<DoctorOrder> {
        return this.getData(`${Endpoints.doctor_order_details}/${pId}`).pipe(map(response => response['Data']['DoctorOrder']));
    }

    getBankAccountList(pParameters: any): Observable<BankAccount[]> {
        return this.postData(Endpoints.bankAccount_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    saveBankAccount(pBankAccount: BankAccount): Observable<BankAccount> {
        return this.postData(pBankAccount.Id ? Endpoints.bankAccount_edit : Endpoints.bankAccount_add, pBankAccount);
    }

    getBankAccount(pBankAccountId: number): Observable<BankAccount> {
        return this.getData(`${Endpoints.bankAccount_details}/${pBankAccountId}`)
            .pipe(map(response => response['Data']['BankAccount']));
    }

    saveOrderAlphaApprovalRule(pApprovalRule: GeneralApprovalRule): Observable<any> {
        return this.postData(Endpoints.add_order_alpha_approval_rule, pApprovalRule);
    }

    deleteOrderAlphaApprovalRule(pApproveRuleId: number): Observable<any> {
        return this.deleteData(`${Endpoints.delete_order_alpha_approval_rule}/${pApproveRuleId}`);
    }

    // dms order

    getDmsOrderDetails(pId: number, pURL: string): Observable<DmsOrderDetails> {
        return this.getDataForMicroService(pURL + `${Endpoints.dms_order_details}/${pId}`).pipe(map(response => response['data']));
    }

    approveDmsOrder(pApproval: DmsApproval, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.dms_order_approve, pApproval).pipe(map(response => response));
    }

    getDmsOrderSummary(params: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.dms_order_list_summary, params).pipe(map(response => response['data']));
    }

    getDeliveryPersonList(params: any): Observable<User[]> {
        return this.postData(Endpoints.list_of_delivery_person, params).pipe(map(response => response['Data']['content']));
    }

    getOrderAlphaDetails(pId: number, pURL: string): Observable<OrderAlphaDetails> {
        return this.getDataForMicroService(pURL + `${Endpoints.order_alpha_details}/${pId}`).pipe(map(response => response['data']));
    }

    getOrderAlphaPreview(pDmsInvoiceRequest: OrderAlphaRequest, pURL: string): Observable<OrderAlphaPreview> {
        return this.postDataForMicroService(pURL + Endpoints.order_alpha_preview, pDmsInvoiceRequest).pipe(map(response => response['data']));
    }

    saveOrderAlpha(pFlatRate: OrderAlphaRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pFlatRate.id ? pURL + Endpoints.order_alpha_edit : pURL + Endpoints.order_alpha_add, pFlatRate).pipe(map(response => response));
    }

    approveOrderAlpha(pApproval: DmsApproval, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.order_alpha_approve, pApproval).pipe(map(response => response));
    }

    resetOrderAlpha(pId: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.order_alpha_reset, pId).pipe(map(response => response));
    }

    getOrderAlphaDetailsByMpo(params, pUrl: string): Observable<OrderAlphaDetailsByMpo[]> {
        return this.postDataForMicroService(pUrl + Endpoints.order_alpha_detail_by_mpo, params).pipe(map(response => response['data']['content']));
    }

    updateOrderStatus(params, pUrl: string): Observable<any> {
        return this.postDataForMicroService(pUrl + Endpoints.update_order_status, params).pipe(map(response => response['data']));
    }

    getOrderAlphaSummary(pFilters: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.order_alpha_total, pFilters).pipe(map(response => response['data']));
    }

    // campaign

    getCampaignList(pParameters: any): Observable<Campaign[]> {
        return this.postData(Endpoints.campaign_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getCampaignDetails(pTargetId: number): Observable<Campaign> {
        return this.getData(`${Endpoints.campaign_details}/${pTargetId}`).pipe(map(response => response['Data']['CampaignCondition']));
    }

    saveCampaign(pTarget: Campaign): Observable<any> {
        return this.postData(pTarget.Id ? Endpoints.campaign_edit : Endpoints.campaign_add, pTarget);
    }

    // dms campaign

    getLineItemOfferDetails(pId: number, pURL: string): Observable<DmsLineItemOfferDetails> {
        return this.getDataForMicroService(pURL + `${Endpoints.line_item_offer_details}?id=${pId}`).pipe(map(response => response['data']));
    }

    getOrderListForDepotDetails(pId: number, pURL: string): Observable<Order> {
        return this.getDataForMicroService(pURL + `${Endpoints.order_details_for_depot_user}?id=${pId}`).pipe(map(response => response['data']));
    }

    saveLineItemOffer(pLineItemOfferRequest: DmsLineItemOfferRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pLineItemOfferRequest.id ? pURL + Endpoints.line_item_offer_update : pURL + Endpoints.line_item_offer_add, pLineItemOfferRequest).pipe(map(response => response));
    }

    changeLineItemOfferStatus(pDepot: ActivationRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.line_item_offer_activate, pDepot).pipe(map(response => response));
    }

    getTotalOrderAmountOfferDetails(pId: number, pURL: string): Observable<DmsTotalOrderAmountOfferDetails> {
        return this.getDataForMicroService(pURL + `${Endpoints.total_order_amount_offer_details}?id=${pId}`).pipe(map(response => response['data']));
    }

    changeTotalOrderAmountOfferStatus(pDepot: ActivationRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.total_order_amount_offer_activate, pDepot).pipe(map(response => response));
    }

    saveTotalOrderAmountOffer(pTotalOrderAmountOfferRequest: DmsTotalOrderAmountOfferRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pTotalOrderAmountOfferRequest.id ? pURL + Endpoints.total_order_amount_offer_update : pURL + Endpoints.total_order_amount_offer_add, pTotalOrderAmountOfferRequest).pipe(map(response => response));
    }

    getFlatRateDetails(pId: number, pURL: string): Observable<DmsFlatRateDetails> {
        return this.postDataForMicroService(pURL + `${Endpoints.flat_rate_details}/${pId}`).pipe(map(response => response['data']));
    }

    saveFlatRate(pFlatRate: DmsFlatRateRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pFlatRate.id ? pURL + Endpoints.flat_rate_edit : pURL + Endpoints.flat_rate_add, pFlatRate).pipe(map(response => response));
    }

    changeFlatRateCampaignStatus(pApproval: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.flat_rate_update_status, pApproval).pipe(map(response => response));
    }

    getDiscountOnSaleDetails(pId: number, pURL: string): Observable<CampaignDiscountOnSaleDetails> {
        return this.postDataForMicroService(pURL + `${Endpoints.discount_on_sale_details}/${pId}`).pipe(map(response => response['data']));
    }

    saveDiscountOnSale(pDiscountOnSaleRequest: CampaignDiscountOnSaleRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pDiscountOnSaleRequest.id ? pURL + Endpoints.discount_on_sale_edit : pURL + Endpoints.discount_on_sale_add, pDiscountOnSaleRequest).pipe(map(response => response));
    }

    changeDiscountOnSaleCampaignStatus(pApproval: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.discount_on_sale_update_status, pApproval).pipe(map(response => response));
    }

    getBonusDetails(pId: number, pURL: string): Observable<DmsBonusDetails> {
        return this.postDataForMicroService(pURL + `${Endpoints.campaign_basic_bonus_details}/${pId}`).pipe(map(response => response['data']));
    }

    saveBonus(pFlatRate: DmsBonusRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pFlatRate.id ? pURL + Endpoints.campaign_basic_bonus_edit : pURL + Endpoints.campaign_basic_bonus_add, pFlatRate).pipe(map(response => response));
    }

    changeBonusCampaignStatus(pApproval: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.campaign_basic_bonus_update_status, pApproval).pipe(map(response => response));
    }

    getSpecialCampaignDetails(pId: number, pURL: string): Observable<DmsSpecialCampaignDetails> {
        return this.postDataForMicroService(pURL + `${Endpoints.special_campaign_details}/${pId}`).pipe(map(response => response['data']));
    }

    saveSpecialCampaign(pSpecial: DmsSpecialCampaignRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pSpecial.id ? pURL + Endpoints.special_campaign_edit : pURL + Endpoints.special_campaign_add, pSpecial).pipe(map(response => response));
    }

    changeSpecialStatus(pApproval: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.special_campaign_update_status, pApproval).pipe(map(response => response));
    }

    getAvailableOptionalSpecialCampaignList(pParameters: any, pURL: string): Observable<OptionalCampaigns[]> {
        return this.getDataForMicroService(pURL + Endpoints.get_available_optional_special_campaign, pParameters).pipe(map(response => response['data']['content']));
    }

    getPartyCampaignDetails(pId: number, pURL: string): Observable<DmsPartyCampaignDetails> {
        return this.postDataForMicroService(pURL + `${Endpoints.party_campaign_details}/${pId}`).pipe(map(response => response['data']));
    }

    savePartyCampaign(pSpecial: DmsPartyCampaignRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pSpecial.id ? pURL + Endpoints.party_campaign_edit : pURL + Endpoints.party_campaign_add, pSpecial).pipe(map(response => response));
    }

    changePartyStatus(pApproval: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.party_campaign_update_status, pApproval).pipe(map(response => response));
    }

    getPartyTypeCampaignDetails(pId: number, pURL: string): Observable<PartyTypeCampaignDetails> {
        return this.postDataForMicroService(pURL + `${Endpoints.party_type_campaign_details}/${pId}`).pipe(map(response => response['data']));
    }

    savePartyTypeCampaign(pSpecial: PartyTypeCampaignManage, pURL: string): Observable<any> {
        return this.postDataForMicroService(pSpecial.id ? (pURL + Endpoints.party_type_campaign_edit) : pURL + Endpoints.party_type_campaign_add, pSpecial).pipe(map(response => response));
    }

    changePartyTypeCampaignStatus(pApproval: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.party_type_campaign_update_status, pApproval).pipe(map(response => response));
    }

    getBundleOfferCampaignDetails(pId: number, pURL: string): Observable<BundleOfferCampaignDetails> {
        return this.getDataForMicroService(pURL + `${Endpoints.bundle_offer_campaign_details}/${pId}`).pipe(map(response => response['data']));
    }

    saveBundleOfferCampaign(pSpecial: BundleOfferCampaignManage, pURL: string): Observable<any> {
        return this.postDataForMicroService(pSpecial.id ? pURL + Endpoints.bundle_offer_campaign_edit : pURL + Endpoints.bundle_offer_campaign_add, pSpecial).pipe(map(response => response));
    }

    changeBundleOfferCampaignStatus(pApproval: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.bundle_offer_campaign_status_update, pApproval).pipe(map(response => response));
    }

    getMixedProductOfferCampaignDetails(pId: number, pURL: string): Observable<MixedProductOfferDetails> {
        return this.getDataForMicroService(pURL + `${Endpoints.mixed_product_offer_campaign_details}/${pId}`).pipe(map(response => response['data']));
    }

    saveMixedProductOfferCampaign(pSpecial: MixedProductOfferManage, pURL: string): Observable<any> {
        return this.postDataForMicroService(pSpecial.id ? pURL + Endpoints.mixed_product_offer_campaign_edit : pURL + Endpoints.mixed_product_offer_campaign_add, pSpecial).pipe(map(response => response));
    }

    changeMixedProductOfferCampaignStatus(pApproval: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.mixed_product_offer_campaign_status_update, pApproval).pipe(map(response => response));
    }

    // invoice
    saveInvoice(pInvoice: Invoice): Observable<any> {
        return this.postData(Endpoints.invoice_add, pInvoice);
    }

    getInv0iceDetails(pInv0iceId: number): Observable<Invoice> {
        return this.getData(`${Endpoints.inv0ice_details}/${pInv0iceId}`).pipe(map(response => response['Data']['Invoice']));
    }

    getOrderProductList(pParameters: any): Observable<OrderProduct[]> {
        return this.postData(Endpoints.order_product_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    // invoice sync
    getInvoiceSyncDetails(pId: number): Observable<InvoiceSync> {
        return this.getData(`${Endpoints.invoice_sync_details}/${pId}`).pipe(map(response => response['Data']['Invoice']));
    }

    // dms invoice

    manageDmsInvoice(pDmsInvoiceRequest: DmsInvoiceRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pDmsInvoiceRequest.id ? pURL + Endpoints.dms_invoice_update : pURL + Endpoints.dms_create_invoice, pDmsInvoiceRequest).pipe(map(response => response));
    }

    getInvoicePreview(pDmsInvoiceRequest: DmsInvoiceRequest, pURL: string): Observable<DmsPricePreview> {
        return this.postDataForMicroService(pURL + Endpoints.dms_invoice_calculate_price, pDmsInvoiceRequest).pipe(map(response => response['data']));
    }

    getDmsInvoiceDetails(pId: number, pURL: string): Observable<DmsInvoiceDetails> {
        return this.getDataForMicroService(pURL + `${Endpoints.dms_invoice_details}/${pId}`).pipe(map(response => response['data']));
    }

    deliverDMSInvoice(pId: number, pURL: string): Observable<DmsInvoiceDetails> {
        return this.putDataForMicroService(pURL + `${Endpoints.dms_invoice_delivery}/${pId}`).pipe(map(response => response['data']));
    }

    rejectDMSInvoice(pId: number, pURL: string, pReason: string): Observable<DmsInvoiceDetails> {
        return this.putDataForMicroService(pURL + `${Endpoints.dms_invoice_reject}/${pId}`, { reason: pReason }).pipe(map(response => response['data']));
    }

    createDmsInvoiceByOrderId(pOrderId: number, pRequestId: string, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.dms_invoice_create_by_order_id, {
            orderId: pOrderId,
            requestId: pRequestId
        }).pipe(map(response => response['data']));
    }

    getInvoiceSummary(pFilters: any, pURL: string, pIsDepotUser: boolean): Observable<any> {
        return this.postDataForMicroService(pIsDepotUser ? pURL + Endpoints.dms_invoice_summary_for_depot_user : pURL + Endpoints.dms_invoice_summary, pFilters).pipe(map(response => response['data']));
    }

    createDmsInvoiceByOrderIdForC2C(pOrderId: number, pRequestId: string, pDeliveryPersonId: number, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.dms_invoice_create_by_order_id, {
            orderId: pOrderId,
            requestId: pRequestId,
            deliveryPersonId: pDeliveryPersonId
        }).pipe(map(response => response['data']));
    }

    deliverDMSInvoiceEqualAmountOfPayment(pId: number, pURL: string): Observable<DmsInvoiceDetails> {
        return this.putDataForMicroService(pURL + `${Endpoints.dms_invoice_delivery_invoice_equal_amount_of_payment}/${pId}`).pipe(map(response => response['data']));
    }

    rejectDMSInvoiceWithPayment(pId: number, pURL: string, pReason: string): Observable<DmsInvoiceDetails> {
        return this.putDataForMicroService(pURL + `${Endpoints.dms_invoice_reject_with_payment}/${pId}`, { reason: pReason }).pipe(map(response => response['data']));
    }

    getMultipleInvoiceToPrint(pIds: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.dms_invoice_list_to_print, pIds).pipe(map(response => response['data']['content']));
    }

    manageDmsInvoiceType(pDmsInvoiceRequest: DmsInvoiceType, pURL: string): Observable<any> {
        return this.postDataForMicroService(pDmsInvoiceRequest.id ? pURL + Endpoints.dms_invoice_type_edit : pURL + Endpoints.dms_invoice_type_add, pDmsInvoiceRequest).pipe(map(response => response));
    }

    getInvoiceTypeDetails(pIds: any, pURL: string): Observable<any> {
        return this.getDataForMicroService(pURL + Endpoints.dms_invoice_type_details, pIds).pipe(map(response => response['data']['content']));
    }

    getInvoiceTypeList(pParameters: any, pURL: string): Observable<DmsInvoiceType[]> {
        return this.postDataForMicroService(pURL + Endpoints.dms_invoice_type_list, pParameters).pipe(map(response => response['data']['content']));
    }

    getProductWiseTopSheet(pParams: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.dms_invoice_product_wise_top_sheet, pParams).pipe(map(response => response['data']['content']));
    }

    addDeliveryReturn(pIds: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.delivery_return_add, pIds).pipe(map(response => response['data']['content']));
    }

    changeDmsDeliveryReturnStatus(pApproval: DmsApproval, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.delivery_return_approve, pApproval).pipe(map(response => response));
    }

    getDeliveryReturnTotal(pFilters: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.delivery_return_total, pFilters).pipe(map(response => response['data']));
    }

    cancelDeliveryReturnStatus(pId: number, pURL: string): Observable<any> {
        return this.putDataForMicroService(pURL + `${Endpoints.delivery_return_cancel}/${pId}`).pipe(map(response => response['data']));
    }

    getInvoiceAlphaDetails(pId: number, pURL: string): Observable<InvoiceAlphaDetails> {
        return this.getDataForMicroService(pURL + `${Endpoints.invoice_alpha_details}/${pId}`).pipe(map(response => response['data']));
    }

    getInvoiceAlphaList(params: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.invoice_alpha_list, params).pipe(map(response => response['data']));
    }

    getInvoiceAlphaPreview(pDmsInvoiceRequest: InvoiceAlphaRequest, pURL: string): Observable<InvoiceAlphaPreview> {
        return this.postDataForMicroService(pURL + Endpoints.invoice_alpha_preview, pDmsInvoiceRequest).pipe(map(response => response['data']));
    }

    saveInvoiceAlpha(pFlatRate: InvoiceAlphaRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pFlatRate.id ? pURL + Endpoints.invoice_alpha_edit : pURL + Endpoints.invoice_alpha_add, pFlatRate).pipe(map(response => response));
    }

    deliverInvoiceAlpha(pId: number, pURL: string): Observable<InvoiceAlphaDetails> {
        return this.putDataForMicroService(pURL + `${Endpoints.invoice_alpha_delivery}/${pId}`).pipe(map(response => response['data']));
    }

    rejectInvoiceAlpha(pId: number, pURL: string, pReason: string): Observable<InvoiceAlphaDetails> {
        return this.postDataForMicroService(pURL + `${Endpoints.invoice_alpha_reject}/${pId}`, { reason: pReason }).pipe(map(response => response['data']));
    }

    resetInvoiceAlpha(pId: any, pURL: string): Observable<any> {
        return this.putDataForMicroService(pURL + `${Endpoints.invoice_alpha_reset}/${pId}`).pipe(map(response => response['data']));
    }

    getInvoiceAlphaSummary(pFilters: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.invoice_alpha_summary, pFilters).pipe(map(response => response['data']));
    }

    getInvoiceTags(pURL: string): Observable<InvoiceTag[]> {
        return this.getDataForMicroService(pURL + Endpoints.invoice_tags).pipe(map(response => response['data']));
    }

    createInvoiceAlphaByOrderId(pOrderId: number, pRequestId: string, pDeliveryPersonId: number, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.multiple_invoice_alpha_create_by_order, {
            orderId: pOrderId,
            requestId: pRequestId,
            deliveryPersonId: pDeliveryPersonId
        }).pipe(map(response => response['data']));
    }

    createPartialInvoice(pOrderId: number, pRequestId: string, pDeliveryPersonId: number, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.create_partial_invoice, {
            orderId: pOrderId,
            requestId: pRequestId,
            deliveryPersonId: pDeliveryPersonId
        }).pipe(map(response => response['data']));
    }

    generateInvoicePdfByIds(params: DeliveryTopSheetReq, pRequestId: string, pURL: string): Observable<any> {
        return this.postDataForMicroServiceForPdf(pURL + Endpoints.invoice_delivery_top_sheet, {
            invoiceIds: params.invoiceIds,
            depotId: params.depotId,
            requestId: pRequestId
        }).pipe(map(response => response.body as Blob));
    }

    generateChallanPDF(pInvoiceIds: any, pURL: string): Observable<any> {
        return this.postDataForMicroServiceForPdf(pURL + Endpoints.depot_challan_export, {
            challanIds: pInvoiceIds,
        }).pipe(map(response => response.body as Blob));
    }

    generateInvoiceSummaryByIds(params: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.invoice_alpha_summary_create, params).pipe(map(response => response['data']));
    }

    generateInvoiceBulkSummary(params: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.invoice_alpha_bulk_summary_create, params).pipe(map(response => response['data']));
    }

    generateSummaryGatePass(params: any, pURL: string): Observable<Blob> {
        return this.postDataForMicroServiceForPdf(pURL + Endpoints.invoice_summary_gatepass, params).pipe(map(response => response.body as Blob));
    }

    generateSummaryChemistDueReport(params: any, pURL: string): Observable<Blob> {
        return this.postDataForMicroServiceForPdf(pURL + Endpoints.invoice_summary_chemist_due_report, params).pipe(map(response => response.body as Blob));
    }

    generateInvoiceSummaryDetails(id: number, pURL: string): Observable<any> {
        return this.getDataForMicroService(pURL + Endpoints.invoice_summary_details + `/${id}`).pipe(map(response => response.data));
    }


    generateSampleGiftChallanPdf(pIds: any, pURL: string): Observable<any> {
        return this.postDataForMicroServiceForPdf(pURL + Endpoints.sample_gift_challan_pdf, {
            challanIds: pIds
        }).pipe(map(response => response.body as Blob));
    }

    generateMonthlyAllowancePdf(pMonthlyAllowanceIds: any, pURL: string): Observable<any> {
        return this.postDataForMicroServiceForPdf(pURL + Endpoints.ma_claim_print, {
            monthlyExpenseIds: pMonthlyAllowanceIds
        }).pipe(map(response => response.body as Blob));
    }

    generateInvoiceDetailsPdf(pInvoiceId: any, pURL: string): Observable<any> {
        return this.postDataForMicroServiceForPdf(pURL + `${Endpoints.invoice_details_pdf}/${pInvoiceId}`).pipe(map(response => response.body as Blob));
    }

    checkStockBeforeBulkInvoiceCreation(params: number[], pURL: string): Observable<StockCheckForOrderDto[]> {
        return this.postDataForMicroService(pURL + Endpoints.check_stock_for_bulk_invoice, params).pipe(map(response => response['data']));
    }

    getMpoInvoiceDue(mpoId: number, invoiceId: number, url: string): Observable<MpoDueByInvoiceId> {
        return this.getDataForMicroService(url + `${Endpoints.invoice_due_by_mpo_and_invoice_id}?mpoId=${mpoId}&invoiceId=${invoiceId}`).pipe(map(response => response['data']));
    }

    // delivery
    approveDelivery(pParameters: any): Observable<any> {
        return this.postData(Endpoints.delivery_approve, pParameters);
    }

    getDeliveryDetails(pDeliveryId: number): Observable<Delivery> {
        return this.getData(`${Endpoints.delivery_details}/${pDeliveryId}`).pipe(map(response => response['Data']['Delivery']));
    }

    addDeliveryReturn_v2(pOrder: DeliveryReturnCreateReq, pUrl: string): Observable<any> {
        return this.postDataForMicroService(pUrl + Endpoints.delivery_return_add_v2, pOrder).pipe(map(response => response));
    }

    getDeliveryReturnPreview(pData: DeliveryReturnCreateReq, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.delivery_return_preview, pData).pipe(map(response => response['data']));
    }

    getReturnReasonList(pParams: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.dms_return_reason_list, pParams).pipe(map(response => response['data']['content']));
    }

    getDeliveryReturnDetailsV2(pId: number, pURL: string): Observable<DeliveryReturnDetails> {
        return this.getDataForMicroService(pURL + `${Endpoints.delivery_return_details_v2}/${pId}`).pipe(map(response => response['data']));
    }

    getChemistWiseUnpaidInvoiceList(pParams: any, url: string): Observable<InvoiceOfChemist[]> {
        return this.postDataForMicroService(url + Endpoints.chemist_wise_unpaid_invoice, pParams)
            .pipe(map(response => response['data']));
    }

    // payment
    savePayment(pPayment: Payment): Observable<any> {
        return this.postData(pPayment.Id ? Endpoints.payment_edit : Endpoints.payment_add, pPayment);
    }

    approvePayment(pParameters: any): Observable<any> {
        return this.postData(Endpoints.payment_approve, pParameters);
    }

    savePaymentMethod(pPaymentMethod: PaymentMethod): Observable<PaymentMethod> {
        return this.postData(pPaymentMethod.Id ? Endpoints.payment_method_edit : Endpoints.payment_method_add, pPaymentMethod);
    }

    getPaymentDetails(pPaymentId: number): Observable<Payment> {
        return this.getData(`${Endpoints.payment_details}/${pPaymentId}`).pipe(map(response => response['Data']['Payment']));
    }

    getPaymentMethodList(pParameters: any): Observable<PaymentMethod[]> {
        return this.postData(Endpoints.payment_method_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getPaymentMethod(pPaymentMethodId: number): Observable<PaymentMethod> {
        return this.getData(`${Endpoints.payment_method_details}/${pPaymentMethodId}`)
            .pipe(map(response => response['Data']['PaymentType']));
    }

    getPaymentApprove(pPaymentApproveRuleId: number): Observable<PaymentApproveRule> {
        return this.getData(`${Endpoints.payment_approve_details}/${pPaymentApproveRuleId}`)
            .pipe(map(response => response['Data']['PaymentApprovalRule']));
    }

    deletePaymentApproveRule(pPaymentApproveRuleId: number): Observable<any> {
        return this.deleteData(`${Endpoints.payment_approve_details}/${pPaymentApproveRuleId}`);
    }

    savePaymentApproveRule(pPaymentApproveRule: PaymentApproveRule): Observable<PaymentApproveRule> {
        return this.postData(pPaymentApproveRule.Id ? Endpoints.payment_approve_edit : Endpoints.payment_approve_add, pPaymentApproveRule);
    }

    getBankAccounts(params: any): Observable<BankAccount[]> {
        return this.postData(Endpoints.bankAccount_list, params).pipe(map(response => response['Data']['content']));
    }

    saveMpoWisePayment(param: any, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.create_mpo_wise_payment, param).pipe(map(response => response));
    }

    // dms payment
    entryDmsPayment(pDmsInvoiceRequest: DmsPaymentRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.dms_payment_entry, pDmsInvoiceRequest).pipe(map(response => response));
    }

    collectDmsPayment(pDmsInvoiceRequest: DmsPaymentRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.dms_payment_collect, pDmsInvoiceRequest).pipe(map(response => response));
    }

    getDmsPaymentDetails(pId: number, pURL: string): Observable<DmsPaymentDetails> {
        return this.getDataForMicroService(pURL + `${Endpoints.dms_payment_details}/${pId}`).pipe(map(response => response['data']));
    }

    approveDmsPayment(pDepot: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.dms_payment_approve, pDepot).pipe(map(response => response));
    }

    resetDmsPayment(pId: number, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + `${Endpoints.dms_payment_reset}/${pId}`).pipe(map(response => response));
    }

    loadPaymentCards(pParams: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.dms_payment_cards, pParams).pipe(map(response => response['data']));
    }

    collectDmsPaymentDuringDelivery(pDmsInvoiceRequest: DmsPaymentRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.collect_payment_during_delivery, pDmsInvoiceRequest).pipe(map(response => response));
    }

    loadTotalPaymentInfo(params: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.total_bank_wise_payment, params).pipe(map(response => response['data']['amount']));
    }

    // incentive collection
    manageIncentiveRule(pIncentiveRule: IncentiveRuleList, pURL: string): Observable<any> {
        return this.postDataForMicroService(pIncentiveRule.id ? pURL + Endpoints.incentive_rule_edit : pURL + Endpoints.incentive_rule_add, pIncentiveRule).pipe(map(response => response));
    }

    generateIncentive(pIncentive: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.generate_incentive, pIncentive).pipe(map(response => response));
    }

    generateIncentiveStatus(pIncentiveId: string, pURL: string): Observable<any> {
        return this.getDataForMicroService(pURL + `${Endpoints.generate_incentive_status}?job_id=${pIncentiveId}`).pipe(map(response => response['data']));
    }

    adjustIncentiveByChemist(pIncentiveId: any, pURL: string): Observable<any> {
        return this.getDataForMicroService(pURL + `${Endpoints.adjust_incentive_by_chemist}?chemist_id=${pIncentiveId}`).pipe(map(response => response['data']));
    }

    dueInvoiceListByChemist(pIncentiveId: any, pURL: string): Observable<any> {
        return this.getDataForMicroService(pURL + `${Endpoints.due_invoice_list_by_chemist}?chemist_id=${pIncentiveId}`).pipe(map(response => response['data']));
    }

    incentiveAdjustmentAdd(pData: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.incentive_adjustment_add, pData).pipe(map(response => response['data']));
    }

    cancelIncentivePayment(pId: number, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + `${Endpoints.incentive_adjustment_cancel}/${pId}`).pipe(map(response => response));
    }

    cancelReturnPayment(pId: number, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + `${Endpoints.return_adjustment_cancel}/${pId}`).pipe(map(response => response));
    }

    uploadIncentive(pData: IncentiveUpload, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.upload_incentive, pData).pipe(map(response => response['data']));
    }

    // central stock
    approveCentralStockTransfer(pApproval: Approval): Observable<any> {
        return this.postData(Endpoints.central_stock_transfer_approve, pApproval);
    }

    saveProductToCentralStock(pCentralStock: CentralStock): Observable<any> {
        return this.postData(Endpoints.central_stock_add, pCentralStock);
    }

    getTransferFromCentralStockDetails(pTransferId: number): Observable<TransferFromCentralStock> {
        return this.getData(`${Endpoints.central_stock_transfer_details}/${pTransferId}`).pipe(map(response => response['Data']['Id']));
    }

    saveStockTransfer(pTransfer: TransferFromCentralStock): Observable<TransferFromCentralStock> {
        return this.postData(Endpoints.stock_transfer_add, pTransfer);
    }

    // stock
    saveStockList(stock: Stock): Observable<any> {
        return this.postData(stock.Id ? Endpoints.stock_edit : Endpoints.stock_add, stock);
    }

    approveStock(pParameters: any): Observable<any> {
        return this.postData(Endpoints.stock_approve, pParameters);
    }

    // sales center
    getSalesCenterList(pParameters: any): Observable<SalesCenter[]> {
        return this.postData(Endpoints.sales_center_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getSalesCenterDetails(pSalesCenterId: number): Observable<SalesCenter> {
        return this.getData(`${Endpoints.sales_center_details}/${pSalesCenterId}`).pipe(map(response => response['Data']['SalesCenter']));
    }

    saveSalesCenter(pSalesCenter: SalesCenter): Observable<any> {
        return this.postData(pSalesCenter.Id ? Endpoints.sales_center_edit : Endpoints.sales_center_add, pSalesCenter);
    }

    getDistributorRouteList(pParameters: any): Observable<DistributorRoute[]> {
        return this.postData(Endpoints.distributor_route_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getSalesCenterOfAMarket(pMarketId): Observable<any> {
        return this.getData(`${Endpoints.sales_center_of_market}/` + `${pMarketId}`).pipe(map(response => response['Data']['SalesCenter']));
    }


    // depot
    manageDepotType(pDepotType: DepotTypeManage, pURL: string): Observable<any> {
        return this.postDataForMicroService(pDepotType.id ? pURL + Endpoints.depot_type_edit : pURL + Endpoints.depot_type_add, pDepotType).pipe(map(response => response));
    }

    changeDepotTypeStatus(pDepotType: ActivationRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.depot_type_activate, pDepotType).pipe(map(response => response));
    }

    getDepotTypeList(params: any, pURL): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.depot_type_list, params).pipe(map(response => response['data']['content']));
    }

    manageDepot(pDepot: DepotManageRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pDepot.id ? pURL + Endpoints.depot_edit : pURL + Endpoints.depot_add, pDepot).pipe(map(response => response));
    }

    changeDepotStatus(pDepot: ActivationRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.depot_activate, pDepot).pipe(map(response => response));
    }

    getDepotList(params: any, pURL): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.depot_list, params).pipe(map(response => response['data']['content']));
    }

    getDepotStockList(params: any, pURL): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.depot_stock_list, params).pipe(map(response => response['data']['content']));
    }

    getDepotDetails(pDepotId: number, pURL: string): Observable<Depot> {
        return this.getDataForMicroService(pURL + `${Endpoints.depot_details}/${pDepotId}`).pipe(map(response => response['data']));
    }

    saveUserDepot(pParameters: any): Observable<any> {
        return this.postData(Endpoints.save_user_depots, pParameters).pipe(map(response => response));
    }

    getDepotListByUserId(pUserId: number): Observable<any> {
        return this.getData(`${Endpoints.depot_list_by_user}/${pUserId}`).pipe(map(response => response['Data']['content']));
    }

    saveMarketDepot(pParameters: any): Observable<any> {
        return this.postData(Endpoints.save_market_depot, pParameters).pipe(map(response => response));
    }

    uploadProductToDepot(pUploadedProduct: DepotProductUpload, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.product_upload_to_depot, pUploadedProduct).pipe(map(response => response));
    }

    saveDepotRequisition(pDepotRequisition: DepotRequisitionRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pDepotRequisition.id ? pURL + Endpoints.depot_update_requisition : pURL + Endpoints.depot_new_requisition, pDepotRequisition).pipe(map(response => response));
    }

    adjustDepotStock(pDepot: AdjustDepotStock, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.adjust_depot_stock, pDepot).pipe(map(response => response));
    }

    getDepotRequisitionDetails(pRequisitionId: number, pURL: string): Observable<DepotRequisitionDetails> {
        return this.getDataForMicroService(pURL + `${Endpoints.depot_requisition_details}?id=${pRequisitionId}`).pipe(map(response => response['data']));
    }

    rejectDepotRequisition(pRequisitonId: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.depot_requisition_reject, pRequisitonId).pipe(map(response => response));
    }

    getDepotChallanFromRequisition(pRequisitionId: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.depot_challan_from_requisition, pRequisitionId).pipe(map(response => response['data']));
    }

    createChallan(pChallanSuggestion: CreateChallanFromRequisitionRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.crate_depot_challan, pChallanSuggestion).pipe(map(response => response));
    }

    getChallanDetails(pChallanId: number, pURL: string): Observable<DepotChallanDetails> {
        return this.getDataForMicroService(pURL + `${Endpoints.challan_details}?id=${pChallanId}`).pipe(map(response => response['data']));
    }

    receiveChallan(pChallan: DepotChallanReceiveRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.receive_challan, pChallan).pipe(map(response => response));
    }

    rejectChallan(pChallan: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.reject_challan, pChallan).pipe(map(response => response));
    }

    saveProductBatchInfo(pProductBatchInfo: DepotProductBatchManageRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pProductBatchInfo.id ? pURL + Endpoints.product_batch_update : pURL + Endpoints.product_batch_add, pProductBatchInfo).pipe(map(response => response));
    }

    deleteProductBatch(id: number, pUrl: string): Observable<any> {
        return this.deleteDataForMicroService(`${pUrl}${Endpoints.product_batch_delete}/${id}`).pipe(map(response => response));
    }

    loadStockCards(pParams: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL, pParams).pipe(map(response => response['data']));
    }

    getAllowedDepotListForFilter(pParams: any, pURL: string): Observable<Depot[]> {
        return this.postDataForMicroService(pURL, pParams).pipe(map(response => response['data']['content']));
    }

    loadTotalDepotStock(params: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.all_depot_stock_report_total, params).pipe(map(response => response['data']));
    }

    createDepotStock(pData: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.create_depot_stock, pData).pipe(map(response => response));
    }

    // return
    getReturnDetails(pId: number): Observable<Return> {
        return this.getData(`${Endpoints.return_details}/${pId}`).pipe(map(response => response['Data']['Return']));
    }

    // dms return
    getDmsReturnReasonList(pParams: any, pURL: string): Observable<DmsReturnReason[]> {
        return this.postDataForMicroService(pURL + Endpoints.dms_return_reason_list, pParams).pipe(map(response => response['data']['content']));
    }

    manageDMSReturnReasonManage(pManage: DmsReturnReasonManage, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + (pManage.id ? Endpoints.dms_return_reason_edit : Endpoints.dms_return_reason_add), pManage).pipe(map(response => response));
    }

    changeDmsReturnReasonStatus(pManage: ActivationRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.dms_return_reason_update_active_status, pManage).pipe(map(response => response));
    }

    getDmsSalesReturnDetails(pId: number, pURL: string): Observable<DmsSalesReturnDetails> {
        return this.getDataForMicroService(pURL + `${Endpoints.dms_sales_return_details}/${pId}`).pipe(map(response => response['data']));
    }

    getInvoiceDetailsForSalesReturn(url: string, invoiceId: number): Observable<SalesReturnDetailsWithInvoice> {
        return this.getDataForMicroService(url + `${Endpoints.get_invoice_details_for_sales_return}/${invoiceId}`).pipe(map(response => response['data']));
    }

    addSalesReturnWithInvoice(payload: any, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.add_sales_return_from_invoice, payload).pipe(map(response => response));
    }

    updateSalesReturnWithInvoice(payload: any, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.update_sales_return_from_invoice, payload).pipe(map(response => response));
    }

    saveDmsSalesReturn(pDmsSalesReturnRequest: DmsSalesReturnRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pDmsSalesReturnRequest.id ? pURL + Endpoints.dms_sales_return_update : pURL + Endpoints.dms_sales_return_add, pDmsSalesReturnRequest).pipe(map(response => response));
    }

    changeDmsSalesReturnStatus(pApproval: DmsApproval, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.dms_sales_return_approve, pApproval).pipe(map(response => response));
    }

    resetSalesReturn(pId: number, pURL: string): Observable<any> {
        return this.putDataForMicroService(pURL + `${Endpoints.reset_dms_sales_return_list}/${pId}`);
    }

    getDmsDeliveryReturnDetails(pId: number, pURL: string): Observable<DeliveryReturn> {
        return this.getDataForMicroService(pURL + `${Endpoints.delivery_return_details}/${pId}`).pipe(map(response => response['data']));
    }

    getReturnTotal(pFilters: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.sales_return_total, pFilters).pipe(map(response => response['data']));
    }

    generateSalesReturnPdf(pId: number, pURL: string): Observable<any> {
        return this.postDataForMicroServiceForPdf(`${pURL + Endpoints.dms_sales_return_pdf}/${pId}`, {}).pipe(map(response => response.body as Blob));
    }

    generateMultipleSalesReturnPdf(pIds: number[], pURL: string): Observable<any> {
        return this.postDataForMicroServiceForPdf(`${pURL + Endpoints.dms_sales_return_bulk_pdf}`, pIds).pipe(map(response => response.body as Blob));
    }

    getEligibleInvoicesForSalesReturn(url: string, param: any): Observable<number[]> {
        const finalParam = {recordsPerPage: 50, pageNumber: 0, ...param};
        return this.postDataForMicroService(url + Endpoints.eligible_invoice_list_for_sales_return, finalParam).pipe(map(response => response['data']['content']));
    }

    /** Sales & Collection Menu Ends */

    /** Site Menu Starts */

    getSiteDetails(pId: number): Observable<Site> {
        return this.getData(`${Endpoints.site_details}/${pId}`).pipe(map(response => response['Data']['Site']));
    }

    approveSite(pParameters: any): Observable<any> {
        return this.postData(Endpoints.site_approve, pParameters);
    }

    getSiteList(pParameters: any): Observable<Site[]> {
        return this.postData(Endpoints.site_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getOwnerTypeList(pParameters: any): Observable<SiteOwner[]> {
        return this.postData(Endpoints.site_owner_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getSiteTypeList(pParameters: any): Observable<SiteType[]> {
        return this.postData(Endpoints.site_type_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    saveSite(pSite: Site): Observable<Site> {
        return this.postData(pSite.Id ? Endpoints.site_edit : Endpoints.site_add, pSite);
    }

    getSiteTypeDetails(pSiteTypeId: number): Observable<SiteType> {
        return this.getData(`${Endpoints.site_type_details}/${pSiteTypeId}`).pipe(map(response => response['Data']['SiteType']));
    }


    getSiteOwnerTypeDetails(pSiteTypeId: number): Observable<SiteOwner> {
        return this.getData(`${Endpoints.site_owner_details}/${pSiteTypeId}`).pipe(map(response => response['Data']['SiteOwnerType']));
    }

    saveSiteType(pSubSegment: SiteType): Observable<any> {
        return this.postData(pSubSegment.Id ? Endpoints.site_type_edit : Endpoints.ssite_type_add, pSubSegment);
    }


    saveSiteOwnerType(pSubSegment: SiteOwner): Observable<any> {
        return this.postData(pSubSegment.Id ? Endpoints.site_owner_edit : Endpoints.ssite_owner_add, pSubSegment);
    }

    saveSurveySiteApproveRule(pVisitApproveRule: VisitApproveRule): Observable<VisitApproveRule> {
        return this.postData(pVisitApproveRule.Id ? Endpoints.survey_site_approve_edit : Endpoints.survey_site_approve_add, pVisitApproveRule);
    }

    /** Site Menu Ends */

    /** Team Management Menu Starts */

    // user
    deleteUserDevice(pDeviceId: number): Observable<any> {
        return this.deleteData(`${Endpoints.delete_user_device}/${pDeviceId}`);
    }

    getUserRoleList(pParameters: any): Observable<UserRole[]> {
        return this.postData(Endpoints.user_role_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getSubordinateSalesRoleList(pParameters: any): Observable<UserRole[]> {
        // return this.getData(Endpoints.subordinate_sales_role_list, pParameters).pipe(map(response => response['Data']['content']));

        return this.getData(`${Endpoints.subordinate_sales_role_list}?access_token=${this.accessToken}`, pParameters).pipe(map(response => response['Data']['content']));
    }

    getUserRoleDetails(pUserRoleId: number): Observable<UserRole> {
        return this.getData(`${Endpoints.user_role_details}/${pUserRoleId}`).pipe(map(response => response['Data']['UserRole']));
    }

    saveUserRole(pUserRole: UserRole): Observable<any> {
        return this.postData(pUserRole.Id ? Endpoints.user_role_edit : Endpoints.user_role_add, pUserRole);
    }

    getAccompanyRoleList(pParameters: any): Observable<UserRole[]> {
        return this.postData(Endpoints.accompany_list, pParameters).pipe(map(response => response['Data']['content']));
    }


    getUserList(pParameters: any): Observable<User[]> {
        return this.postData(Endpoints.user_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getUserListByAccessibleMarket(pParameters: any): Observable<User[]> {
        return this.postData(Endpoints.user_list_by_accessible_market, pParameters).pipe(map(response => response['Data']['content']));
    }

    getUserDetails(pUserId: number): Observable<User> {
        return this.getData(`${Endpoints.user_details}/${pUserId}`).pipe(map(response => response['Data']['User']));
    }

    changeUserStatus(pApproval: any): Observable<any> {
        return this.postData(Endpoints.change_user_status, pApproval);
    }

    saveUser(pUser: User): Observable<any> {
        return this.postData(pUser.Id ? Endpoints.user_edit : Endpoints.user_add, pUser);
    }

    saveDepotUser(pUser: DepotUser): Observable<any> {
        return this.postData(pUser.Id ? Endpoints.user_edit : Endpoints.user_add, pUser);
    }

    saveChangedPassword(pParameters: Password): Observable<any> {
        return this.postData(Endpoints.change_password, pParameters).pipe(map(response => response['Data']['content']));
    }

    uploadUserCredit(pParameters: any): Observable<any> {
        return this.postData(Endpoints.user_credit_upload, pParameters).pipe(map(response => response['Data']));
    }

    getUserBookedAmount(pUserId: number): Observable<any> {
        return this.getDataForMicroService(base_urls.dms + `${Endpoints.user_booked_amount}/${pUserId}`).pipe(map(response => response));
    }

    getUserDetailsDistanceWiseTaDaLocation(pId: number): Observable<DistanceWiseTaDaRule> {
        return this.getData(`${Endpoints.user_details_distance_wise_ta_da_rule_location}/${pId}`).pipe(map(response => response['Data']['UserDistanceWiseTaDaRule']));
    }

    getMpoList(pParameters: any): Observable<MpoListDto[]> {
        return this.getData(Endpoints.mpo_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getMpoBySearch(pParameters: any, url: string): Observable<UserOfASpecificMarket[]> {
        return this.postDataForMicroService(url + Endpoints.find_mpo_by_search, pParameters).pipe(map(response => response['data']));
    }

    // tour plan
    getTourPlanList(pParameters: any): Observable<TourPlan[]> {
        return this.postData(Endpoints.tour_plan_list, pParameters).pipe(map(response => response['Data']));
    }

    getTourPlanListV2(pParameters: any): Observable<any> {
        return this.postData(Endpoints.tour_plan_list_v2, pParameters).pipe(map(response => response['Data']['TourPlanInfo']));
    }

    getTourPlanDetails(pTourPlanId: number): Observable<TourPlan> {
        return this.getData(`${Endpoints.tour_plan_details}/${pTourPlanId}`).pipe(map(response => response['Data']['TourPlan']));
    }

    getTourPlanDetailsByUserYearMonth(pUserId: number, pYear: number, pMonth: number): Observable<TourPlan> {
        return this.getData(`${Endpoints.tour_plan_details_by_user_year_month}?UserId=${pUserId}&Year=${pYear}&Month=${pMonth}`).pipe(map(response => response['Data']['TourPlan']));
    }

    saveTourPlan(pTourPlan: TourPlan): Observable<any> {
        return this.postData(Endpoints.tour_plan_manage, pTourPlan);
    }

    approveTourPlan(pApproval: Approval): Observable<any> {
        return this.postData(Endpoints.tour_plan_approve, pApproval);
    }

    getTourApprove(pLeaveRuleId: number): Observable<TourPlanApproveRule> {
        return this.getData(`${Endpoints.tourplan_approve_details}/${pLeaveRuleId}`)
            .pipe(map(response => response['Data']['PaymentApprovalRule']));
    }

    resetTourPlan(pParameters: any): Observable<any> {
        return this.postData(Endpoints.tourplan_reset, pParameters).pipe(map(response => response['Data']['Success']));
    }

    saveTourApproveRule(pLeaveApproveRule: UserLeaveApproveRule): Observable<UserLeaveApproveRule> {
        return this.postData(pLeaveApproveRule.Id ? Endpoints.tourplan_approve_edit : Endpoints.tourplan_approve_add, pLeaveApproveRule);
    }

    deleteTourplanApproveRule(pLeaveApproveRuleId: number): Observable<any> {
        return this.deleteData(`${Endpoints.tourplan_approve_delete}/${pLeaveApproveRuleId}`);
    }

    // getTourPlanList(pParameters: any): Observable<TourPlan[]> {
    //     return this.postData( Endpoints.tour_plan_list, pParameters).pipe(map(response => response['Data']['content']));
    // }

    getTourTypeList(pParameters: any): Observable<TourType[]> {
        return this.postData(Endpoints.tour_type_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getTourPurposeList(pParameters: any): Observable<TourPurpose[]> {
        return this.postData(Endpoints.tour_purpose_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getTourTypeDetails(pTourTypeId: number): Observable<TourType> {
        return this.getData(`${Endpoints.tour_type_details}/${pTourTypeId}`).pipe(map(response => response['Data']['TourType']));
    }

    getTourPurposeDetails(pTourPurposeId: number): Observable<TourPurpose> {
        return this.getData(`${Endpoints.tour_purpose_details}/${pTourPurposeId}`).pipe(map(response => response['Data']['TourPurpose']));
    }

    saveTourType(pTourType: TourType): Observable<any> {
        return this.postData(pTourType.Id ? Endpoints.tour_type_edit : Endpoints.tour_type_add, pTourType);
    }

    saveTourPurpose(pTourPurpose: TourPurpose): Observable<any> {
        return this.postData(pTourPurpose.Id ? Endpoints.tour_purpose_edit : Endpoints.tour_purpose_add, pTourPurpose);
    }

    getTourPlanOfAPerson(pParameters: any): Observable<TourPlanOfAPerson[]> {
        return this.postData(Endpoints.tour_plan_of_a_person, pParameters).pipe(map(response => response['Data']['content']));
    }

    getMarketFrequencyOfAPerson(pParameters: any): Observable<TourPlanMarketFrequencyOfAPerson[]> {
        return this.postData(Endpoints.tour_plan_market_frequency_of_a_person, pParameters).pipe(map(response => response['Data']['content']));
    }

    getTourTypeFrequencyOfAPerson(pParameters: any): Observable<TourPlanTourTypeFrequency[]> {
        return this.postData(Endpoints.tour_plan_tour_type_frequency, pParameters).pipe(map(response => response['Data']['content']));
    }

    // market structure
    getMarketLevelList(pOrganizationId: number, pResponseFields?: string): Observable<MarketLevel[]> {
        return this.getData(`${Endpoints.market_level_list}?organizationId=${pOrganizationId}&responseFields=${pResponseFields}`).pipe(map(response => response['Data']['MarketLevelHierarchy']));
    }

    getMarketMiniList(pMarketLevelId: number, pMarketIdList?: number, searchKey?: string): Observable<Market[]> {
        return this.getData(`${Endpoints.market_mini_list}?access_token=${this.accessToken}&MarketLevelId=${pMarketLevelId}${pMarketIdList ? ('&MarketIdList=' + pMarketIdList) : ''}`).pipe(map(response => response['Data']['content']));
    }

    getPaginatedMarketMiniList(pMarketLevelId: number, pMarketIdList?: number, searchKey?: string): Observable<Market[]> {
        return this.getData(`${Endpoints.market_mini_list}?access_token=${this.accessToken}&MarketLevelId=${pMarketLevelId}${pMarketIdList ? ('&MarketIdList=' + pMarketIdList) : ''}${searchKey ? ('&SearchKey=' + searchKey) : ''}&PageNumber=${0}&RecordsPerPage=${50}`).pipe(map(response => response['Data']['content']));
    }

    getMarketLevelDetails(pMarketLevelId: number): Observable<MarketLevel> {
        return this.getData(`${Endpoints.market_level_details}/${pMarketLevelId}`).pipe(map(response => response['Data']['MarketLevel']));
    }

    saveMarketLevel(pMarketLevel: MarketLevel): Observable<any> {
        return this.postData(pMarketLevel.Id ? Endpoints.market_level_edit : Endpoints.market_level_add, pMarketLevel);
    }

    deleteMarketLevel(pMarketLevelId: number): Observable<any> {
        return this.deleteData(`${Endpoints.market_level_delete}/${pMarketLevelId}`);
    }

    getMarketList(pParameters: any): Observable<Market[]> {
        return this.postData(Endpoints.market_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getMarketDetails(pMarketId: number): Observable<Market> {
        return this.getData(`${Endpoints.market_details}/${pMarketId}`).pipe(map(response => response['Data']['Market']));
    }

    saveMarket(pMarket: Market): Observable<any> {
        return this.postData(pMarket.Id ? Endpoints.market_edit : Endpoints.market_add, pMarket);
    }

    deleteMarket(pMarketId: number): Observable<any> {
        return this.deleteData(`${Endpoints.market_delete}/${pMarketId}`);
    }

    /** Team Management Menu Ends */

    deleteSurveyApproveRule(pVisitApproveRuleId: number): Observable<any> {
        return this.deleteData(`${Endpoints.survey_approve_delete}/${pVisitApproveRuleId}`);
    }

    deleteCustomerApproveRule(pCustomerApproveRuleId: number): Observable<any> {
        return this.deleteData(`${Endpoints.customer_approve_delete}/${pCustomerApproveRuleId}`);
    }

    // due report
    getInvoiceAndDueByUserTotal(pFilters: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.dms_invoice_and_due_by_user_report_total, pFilters).pipe(map(response => response['data']));
    }

    getInvoiceAndDueByChemistTotal(pFilters: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.dms_invoice_and_due_by_chemist_report_total, pFilters).pipe(map(response => response['data']));
    }

    getDMSChemistSalesDetailsTotal(pFilters: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.dms_chemist_sales_details_total, pFilters).pipe(map(response => response['data']));
    }

    // sales report
    getProductWiseSalesSummaryTotal(pFilters: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.product_wise_sales_summary_total, pFilters).pipe(map(response => response['data']));
    }

    getProductWiseSalesSummaryTotalForAllTab(pFilters: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.product_wise_sales_summary_total_for_all_tab, pFilters).pipe(map(response => response['data']));
    }

    getSalesReportUserRoles(pURL: string): Observable<any> {
        return this.getDataForMicroService(pURL + `${Endpoints.sales_report_roles}`).pipe(map(response => response['data']['content']));
    }

    getPartyWiseSalesTotal(pFilters: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.party_wise_sales_total, pFilters).pipe(map(response => response['data']));
    }

    generatePartyWiseSalesPdf(pParams: any, pURL: string): Observable<any> {
        return this.postDataForMicroServiceForPdf(pURL + Endpoints.party_wise_sales_pdf, pParams).pipe(map(response => response.body as Blob));
    }

    getMarketUserWiseSalesTotal(pFilters: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.market_user_wise_sales_total, pFilters).pipe(map(response => response['data']));
    }

    // doctor service
    saveDoctorServiceApprovalRule(pApprovalRule: PrescriptionApproveRule): Observable<any> {
        return this.postData(Endpoints.doctor_service_approval_rule_add, pApprovalRule);
    }

    deleteDoctorServiceApprovalRule(pApprovalRuleId: number): Observable<any> {
        return this.deleteData(`${Endpoints.doctor_service_approval_rule_delete}/${pApprovalRuleId}`);
    }

    saveDoctorServiceProposalType(pData: DoctorServiceProposalTypeRequest): Observable<any> {
        return this.postData(pData.Id ? Endpoints.doctor_service_proposal_type_update : Endpoints.doctor_service_proposal_type_add, pData);
    }

    saveDoctorServicePaymentMethod(pData: DoctorPaymentMethodDto): Observable<any> {
        return this.postData(pData.Id ? Endpoints.doctor_payment_method_update : Endpoints.doctor_payment_method_add, pData);
    }

    getDoctorServiceProposalType(params: any): Observable<DoctorServiceProposalTypeDto[]> {
        return this.postData(Endpoints.doctor_service_proposal_type_list, params).pipe(map(response => response['Data']['content']));
    }

    getDoctorProposalDetails(pProposalId: number): Observable<DoctorServiceProposalDetailDto> {
        return this.getData(`${Endpoints.doctor_service_proposal_detail}/${pProposalId}`).pipe(map(response => response['Data']['Proposal']));
    }

    updateDoctorProposalStatus(pApproval: any): Observable<any> {
        return this.postData(Endpoints.doctor_service_status_change, pApproval);
    }

    // payment collection

    getDmsPaymentCollectionDetails(pId: number, pURL: string): Observable<PaymentCollection> {
        return this.getDataForMicroService(pURL + `${Endpoints.payment_collection_details}/${pId}`).pipe(map(response => response['data']));
    }

    changeDmsPaymentCollectionStatus(pApproval: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.payment_collection_approve, pApproval).pipe(map(response => response));
    }

    cancelDmsPaymentCollectionStatus(pId: number, pURL: string): Observable<PaymentCollection> {
        return this.putDataForMicroService(pURL + `${Endpoints.payment_collection_cancel}/${pId}`).pipe(map(response => response['data']));
    }

    changeMpoWisePaymentCollectionStatus(pApproval: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.mpo_wise_payment_collection_approve, pApproval).pipe(map(response => response));
    }

    cancelMpoWisePaymentCollectionStatus(pId: number, pURL: string): Observable<PaymentCollection> {
        return this.putDataForMicroService(pURL + `${Endpoints.mpo_wise_payment_collection_cancel}/${pId}`).pipe(map(response => response['data']));
    }

    getChemistDue(chemistId: number, baseUrl: string): Observable<any> {
        const url = `${baseUrl}/${Endpoints.payment_collection_chemist_due}?chemistId=${chemistId}`;
        return this.getDataForMicroService(url, {}).pipe(map(response => response));
    }

    getChemistDueInvoiceTypeWise(chemistId: number, params: string, baseUrl: string): Observable<InvoiceDueInfo> {
        const url = `${baseUrl}/${Endpoints.payment_collection_chemist_due}${params}`;
        return this.getDataForMicroService(url, {}).pipe(map(response => response['data']));
    }

    createPaymentCollection(pData: PaymentCollectionManage, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.payment_collection_create, pData).pipe(map(response => response));
    }

    createPaymentCollection_v2(pData: PaymentCollectionRequest, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.payment_collection_create, pData).pipe(map(response => response));
    }

    printPaymentCollectionReceipt(collectionId: number, pURL: string): Observable<any> {
        return this.postDataForMicroServiceForPdf(pURL + Endpoints.payment_collection_receipt_print, {
            paymentCollectionId: collectionId
        }).pipe(map(response => response.body as Blob));
    }

    printMpoWisePaymentCollectionPdf(pParams: any, pURL: string): Observable<any> {
        return this.postDataForMicroServiceForPdf(pURL + Endpoints.print_mpo_wise_payment_collection_pdf, pParams).pipe(map(response => response.body as Blob));
    }
    // patient

    createPatient(pPatient: PatientCreateDto, pURL: string, userName = 'system'): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.patient_manage, pPatient, true, userName).pipe(map(response => response));
    }

    updatePatient(pPatient: PatientCreateDto, pURL: string, userName = 'system'): Observable<any> {
        return this.putDataForMicroService(`${pURL}${Endpoints.patient_manage}/${pPatient.patientId}`, pPatient, true, userName).pipe(map(response => response));
    }

    getPatientList(pParams: any, pURL: string): Observable<any> {
        return this.getDataForMicroService(pURL + Endpoints.patient_list, pParams).pipe(map(response => response));
    }

    getPatientDetails(pPatientId, pURL: string): Observable<PatientDetailsDto> {
        return this.getDataForMicroService(`${pURL}/${Endpoints.patient_details}/${pPatientId}`).pipe(map(response => response['data']));
    }

    getPatientThroughSearching(params, pURL: string): Observable<any> {
        return this.getDataForMicroService(`${pURL}${Endpoints.patient_search}`, params).pipe(map(response => response));
    }

    updatePatientDeath(pPatient: any, pURL: string, userName = 'system'): Observable<any> {
        return this.postDataForMicroService(`${pURL}${Endpoints.patient_manage}/${pPatient.patientId}/death`, pPatient, true, userName).pipe(map(response => response));
    }

    getRunningOutOfDrugsPatients(pParams: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(`${pURL}${Endpoints.running_out_of_drugs_patient_list}`, pParams, true).pipe(map(response => response));
    }

    getPatientAndProductDirectory(pParams: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(`${pURL}${Endpoints.patient_and_product_directory}`, pParams, true).pipe(map(response => response));
    }

    // patient rx order

    addPatientRxOrder(pOrder: PatientRxOrderCreateDto, pUrl: string): Observable<any> {
        return this.postDataForMicroService(pUrl + Endpoints.patient_rx_order_add, pOrder).pipe(map(response => response));
    }

    editPatientRxOrder(pOrder: PatientRxOrderCreateDto, pUrl: string): Observable<any> {
        return this.putDataForMicroService(`${pUrl}${Endpoints.patient_rx_order_edit}/${pOrder.rxId}`, pOrder).pipe(map(response => response));
    }

    getPatientRxOrderList(params: any, pURL: string): Observable<any> {
        return this.getDataForMicroService(pURL + Endpoints.patient_rx_order_list, params).pipe(map(response => response));
    }

    getPatientRxOrderDetails(pOrderId, pURL: string): Observable<PatientRxOrderDetails> {
        return this.getDataForMicroService(`${pURL}${Endpoints.patient_rx_order_details}/${pOrderId}`, {}).pipe(map(response => response));
    }

    getFollowUpDates(patientId, url: string): Observable<any> {
        return this.getDataForMicroService(`${url}${Endpoints.follow_up_patient}/${patientId}`, {}).pipe(map(response => response));
    }

    uploadBulkInvoice(uploadData: InvoiceBulkUpload, url): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.invoice_bulk_upload_for_patient, uploadData).pipe(map(response => response));
    }

    // user

    getUserListByIds(idList): Observable<any> {
        return this.postData(Endpoints.user_list_by_ids, { Ids: idList }).pipe(map(response => response['Data']['content']));
    }

    getMPOUserList(pParameters: any): Observable<PatientMpo[]> {
        return this.postData(Endpoints.all_user_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getAllMPO(pParameters: any): Observable<PatientMpo[]> {
        return this.postData(Endpoints.all_user_mpo_list, pParameters).pipe(map(response => response['Data']['content']));
    }

    getSampleGiftChallanUserList(pParameters: any, url: string): Observable<SampleGiftChallanFieldForce[]> {
        return this.postDataForMicroService(url + Endpoints.sample_gift_challan_user_filter, pParameters)
            .pipe(map(response => (response && response.data && response.data.content) ? response.data.content : []));
    }


    // market
    getMarketListByIds(idList): Observable<any> {
        return this.postData(Endpoints.market_list_by_ids, { Ids: idList }).pipe(map(response => response['Data']['content']));
    }

    getMpoMarketLevel(url): Observable<MpoMarketLevel> {
        return this.getDataForMicroService(`${url}${Endpoints.mpo_marketLevel}`).pipe(map(response => response['data']));
    }

    getUsersAndMarketsByMarketLevel(pParams: any, pURL: string): Observable<MarketAndUserOfALevel[]> {
        return this.postDataForMicroService(pURL + Endpoints.market_and_users_of_a_level, pParams).pipe(map(response => response['data']['content']));
    }

    getMarketsForProductMarketLevelWiseSales(param: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.product_and_market_level_wise_sales_summary_markets, param).pipe(map(response => response['data']));
    }

    getMarketProductLineWiseSales(param: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.market_and_product_line_wise_sales_product_line_list, param).pipe(map(response => response['data']));
    }

    // doctor
    getDoctorListByIds(idList): Observable<any> {
        return this.postData(Endpoints.doctor_list_by_ids, { Ids: idList }).pipe(map(response => response['Data']['content']));
    }

    getDoctorListOfMpo(params): Observable<PatientRxOrderDoctor[]> {
        return this.postData(Endpoints.doctor_list_of_mpo, params).pipe(map(response => response['Data']['content']));
    }

    getAllDoctor(params): Observable<PatientRxOrderDoctor[]> {
        return this.postData(Endpoints.doctor_all_list_for_filter, params).pipe(map(response => response['Data']['content']));
    }

    // sales center
    getSalesCenterListByIds(idList): Observable<any> {
        return this.postData(Endpoints.sales_center_list_by_ids, { Ids: idList }).pipe(map(response => response['Data']['content']));
    }


    // patient dashboard

    getPatientDashboardSummary(pParams: any, pURL: string): Observable<any> {
        return this.getDataForMicroService(`${pURL}${Endpoints.patient_dashboard_summary}`, pParams).pipe(map(response => response));
    }

    getDepotWiseInvoiceSummary(pParams: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.depot_wise_patient_invoice_summary, pParams).pipe(map(response => response['content']));
    }

    getRunningOutOfDrugsPatientNumber(pParams: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.running_out_of_drugs_patients_number, pParams).pipe(map(response => response['numberOfPatientsRunningOutOfDrugs']));
    }

    // weekend

    getWeekendRequestDetails(id: number, url: string): Observable<WeekendDetails> {
        return this.getDataForMicroService(`${url}${Endpoints.weekend_request_details}?id=${id}`, {}).pipe(map(response => response['data']));
    }

    getApprovedWeekendsOfUser(pParams: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.approved_weekend_date_of_user, pParams).pipe(map(response => response['data']['content']));
    }

    editWeekendRequest(pParams: WeekendEditReq, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.weekend_request_edit, pParams).pipe(map(response => response['data']));
    }

    approveMonthlyWeekendRequest(pParameters: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.monthly_weekend_request_approve, pParameters);
    }

    approveDAClaimList(pParameters: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.da_claim_approve, pParameters);
    }

    approveVehicle(pParameters: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.user_vehicle_approve, pParameters);
    }

    bulkStatusChangeOfPendingMonthlyAllowances(pParameters: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.ma_claim_bulk_approve, pParameters);
    }

    maClaimApproveAll(pParameters: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.ma_claim_approve_all, pParameters);
    }

    maClaimRejectAll(pParameters: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.ma_claim_reject_all, pParameters);
    }

    // ma claim
    generateMAClaim(pParams: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.ma_claim_generate, pParams).pipe(map(response => response['data']['success']));
    }

    reGenerateMAClaim(pParams: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.ma_claim_regenerate, pParams).pipe(map(response => response['data']['success']));
    }

    editMAClaim(pParams: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.edit_ma_claim, pParams).pipe(map(response => response['data']['success']));
    }

    getMAClaimDetails(id: number, url: string): Observable<MonthlyAllowanceDetails> {
        return this.getDataForMicroService(`${url}${Endpoints.ma_claim_details}?id=${id}`, {}).pipe(map(response => response['data']));
    }

    approveMAClaimList(pParameters: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.ma_claim_approved, pParameters);
    }

    generateAllMaClaim(pParameters: any, pURL: string): Observable<any> {
        return this.postDataForMicroService(pURL + Endpoints.generate_all_ma_claim, pParameters).pipe(map(response => response['data']['message']));
    }

    // role wise allowance rule

    editRoleWiseDailyAllowance(param: any, url: string): Observable<any> {
        return this.postDataForMicroService(`${url}${Endpoints.role_wise_da_rule_update}`, param).pipe(map(response => response['data']['success']));
    }

    addRoleWiseDailyAllowance(param: RoleWiseAllowanceAdd, url: string): Observable<any> {
        return this.postDataForMicroService(`${url}${Endpoints.role_wise_da_rule_add}`, param).pipe(map(response => response['data']['success']));
    }

    changeDailyAllowanceStatus(pId: number, url: string): Observable<any> {
        return this.postDataForMicroService(`${url}${Endpoints.role_wise_da_rule_inactive}/${pId}`, {}).pipe(map(response => response['data']['success']));
    }
    activeDailyAllowanceStatus(pId: number, url: string): Observable<any> {
        return this.postDataForMicroService(`${url}${Endpoints.role_wise_da_rule_active}/${pId}`, {}).pipe(map(response => response['data']['success']));
    }
    deleteDailyAllowanceStatus(pId: number, url: string): Observable<any> {
        return this.deleteDataForMicroService(`${url}${Endpoints.role_wise_da_rule_delete}/${pId}`, {}).pipe(map(response => response['data']['success']));
    }

    editRoleWiseMonthlyAllowance(params: any, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.role_wise_monthly_allowance_update, params).pipe(map(response => response['data']['success']));
    }

    addRoleWiseMonthlyAllowance(param: RoleWiseAllowanceAdd, url: string): Observable<any> {
        return this.postDataForMicroService(`${url}${Endpoints.role_wise_monthly_allowance_add}`, param).pipe(map(response => response['data']['success']));
    }

    changeMonthlyAllowanceStatus(pId: number, url: string): Observable<any> {
        return this.postDataForMicroService(`${url}${Endpoints.role_wise_monthly_allowance_inactive}/${pId}`, {}).pipe(map(response => response['data']['success']));
    }

    deleteMonthlyAllowanceStatus(pId: number, url: string): Observable<any> {
        return this.deleteDataForMicroService(`${url}${Endpoints.role_wise_monthly_allowance_delete}/${pId}`, {}).pipe(map(response => response['data']['success']));
    }

    changeRoleWiseExpenseTypeStatus(params: any, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.role_wise_expense_type_change_activation, params).pipe(map(response => response['data']['success']));
    }

    manageRoleWiseExpenseType(params: any, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.role_wise_expense_type_manage, params).pipe(map(response => response['data']['success']));
    }

    roleWiseMonthlyAllowanceActivation(params: any, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.role_wise_monthly_allowance_activation, params).pipe(map(response => response['data']));
    }

    deleteRoleWiseExpenseType(params: any, url: string): Observable<any> {
        return this.deleteDataForMicroService(url + Endpoints.role_wise_expense_type_delete, params).pipe(map(response => response['data']['success']));
    }

    // geo market

    getDistrictList(params: any, url: string): Observable<DistrictListDto[]> {
        return this.postDataForMicroService(`${url}${Endpoints.district_list}`, params).pipe(map(response => response));
    }

    changeDistrictStatus(params: any, url: string): Observable<any> {
        return this.postDataForMicroService(`${url}${Endpoints.change_district_status}`, params).pipe(map(response => response['data']));
    }

    manageDistrict(params: DistrictManageDto, url: string): Observable<any> {
        return this.postDataForMicroService(`${url}${params.id ? Endpoints.district_edit : Endpoints.district_add}`, params).pipe(map(response => response['data']));
    }

    getThanaList(params: any, url: string): Observable<ThanaDto[]> {
        return this.postDataForMicroService(`${url}${Endpoints.thana_list}`, params).pipe(map(response => response));
    }

    changeThanaStatus(params: any, url: string): Observable<any> {
        return this.postDataForMicroService(`${url}${Endpoints.change_thana_status}`, params).pipe(map(response => response['data']));
    }

    manageThana(params: ThanaManageDto, url: string): Observable<any> {
        return this.postDataForMicroService(`${url}${params.id ? Endpoints.thana_edit : Endpoints.thana_add}`, params).pipe(map(response => response['data']));
    }

    getUnionList(params: any, url: string): Observable<UnionDto[]> {
        return this.postDataForMicroService(`${url}${Endpoints.union_list}`, params).pipe(map(response => response));
    }

    changeUnionStatus(params: any, url: string): Observable<any> {
        return this.postDataForMicroService(`${url}${Endpoints.change_union_status}`, params).pipe(map(response => response['data']));
    }

    manageUnion(params: UnionManageDto, url: string): Observable<any> {
        return this.postDataForMicroService(`${url}${params.id ? Endpoints.union_edit : Endpoints.union_add}`, params).pipe(map(response => response['data']));
    }

    // doctor report

    getRxDcrFrequencies(params: any, url: string): Observable<RxFrequencyListRes> {
        return this.postDataForMicroService(`${url}${Endpoints.rx_dcr_frequencies}`, params).pipe(map(response => response['data']));
    }

    getDoctorCoverageByMarket(params: any, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.doctor_coverage_v2, params).pipe(map(response => response['data']));
    }

    // Free Challan Purpose
    getFreeChallanPurposeList(params: any, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.free_challan_purpose_list, params).pipe(map(response => response['data']));
    }

    manageFreeChallanPurpose(params: any, url: string): Observable<any> {
        return this.postDataForMicroService(url + (params.id ? Endpoints.free_challan_purpose_edit : Endpoints.free_challan_purpose_add), params).pipe(map(response => response));
    }

    changeFreeChallanPurposeStatus(params: any, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.free_challan_purpose_activate, params).pipe(map(response => response));
    }

    getFreeChallanPurposeDetails(id: number, url: string): Observable<any> {
        return this.getDataForMicroService(`${url}${Endpoints.free_challan_purpose_list}/${id}`).pipe(map(response => response['data']));
    }

    // Free Challan Issue
    getFreeChallanIssueList(params: FreeChallanIssueListRequest, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.free_challan_issue_list, params).pipe(map(response => response['data']));
    }

    createFreeChallanIssue(params: FreeChallanIssueCreateRequest, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.free_challan_issue_create, params).pipe(map(response => response));
    }

    cancelFreeChallanIssue(id: number, url: string): Observable<any> {
        return this.putDataForMicroService(`${url}${Endpoints.free_challan_issue_cancel}/${id}`).pipe(map(response => response['data']));
    }

    getFreeChallanIssueDetails(id: number, url: string): Observable<FreeChallanIssueDetailsDto> {
        return this.getDataForMicroService(`${url}${Endpoints.free_challan_issue_details}/${id}`).pipe(map(response => response['data']));
    }

    // Replacement Request
    getReplacementRequestList(params: any, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.replacement_request_list, params).pipe(map(response => response['data']));
    }

    exportReplacementRequestList(params: any, url: string): Observable<any> {
        return this.generateAsyncGetUrlForMicroservice(url + Endpoints.replacement_request_list_export, params);
    }

    approveReplacementRequest(params: { id: number; approved: boolean }, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.replacement_request_approve, params).pipe(map(response => response['data']));
    }

    resetReplacementRequest(params: { id: number }, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.replacement_request_reset, params).pipe(map(response => response['data']));
    }

    createReplacementRequest(params: ReplacementRequestCreateRequest, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.replacement_request_create, params).pipe(map(response => response['data']));
    }

    getReplacementRequestDetails(id: number, url: string): Observable<ReplacementRequestDetailsDto> {
        return this.getDataForMicroService(`${url}${Endpoints.replacement_request_details}/${id}`).pipe(map(response => response['data']));
    }

    editReplacementRequest(params: ReplacementRequestEditRequest, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.replacement_request_edit, params).pipe(map(response => response['data']));
    }

    // Replacement Invoice
    createInvoiceByReplacement(params: InvoiceAlphaByReplacementRequest, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.invoice_create_by_replacement, params).pipe(map(response => response['data']));
    }

    editInvoiceByReplacement(params: InvoiceAlphaByReplacementEditRequest, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.invoice_edit_by_replacement, params).pipe(map(response => response['data']));
    }

    bulkCreateInvoiceByReplacement(params: InvoiceAlphaBulkByReplacementRequest, url: string): Observable<any> {
        return this.postDataForMicroService(url + Endpoints.invoice_bulk_create_by_replacement, params).pipe(map(response => response['data']));
    }
}

